import { Box, Typography } from "@mui/material";
import {
  useEffect,
  useState,
  useMemo,
  useCallback,
  lazy,
  Suspense,
  useTransition,
} from "react";
import React from "react";
import "../../cssfiles/homepage.css";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { Checkbox } from "@mui/material";
import CustomButton from "../CommonComponents/CustomButton";
import CustomActionButton from "../CommonComponents/CustomActionButton";
import CustomTableHeading from "../CommonComponents/CustomTableHeading";
import CustomTableHeadingHarmonics from "../CommonComponents/CustomTableHeadingHarmonics";
import CustomTableMetric from "../CommonComponents/CustomTableMetric";
import CustomLabel from "../CommonComponents/CustomLabel";
import CustomTextField from "../CommonComponents/CustomTextField";
import CustomCancelButton from "../CommonComponents/CustomCancelButton";
import CustomDialogBox from "../CommonComponents/CustomDialogBox";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Backdrop,
  CircularProgress,
  Grid,
} from "@mui/material";
import AssetTagsRetrievalModified from "./AssetTagsRetrievalModified";
import { useSelector } from "react-redux";
import Paper from "@mui/material/Paper";
import LK_Delete from "../../images/LK_Delete";
import CheckBoxOutlinedIcon from "@mui/icons-material/CheckBoxOutlined";
import {
  postalarmconfig,
  postpowerqualityconfiguration,
  getpowerqualityconfiguration,
  getdashboarlist,
  linkDashboardtoTemplate,
  getSCMaxLoadCurrentThreshold,
  deletepowerqualityconfiguration,
  deletecurrentpowerqualityconfiguration,
  fetchPowerQualityData,
  getdevicetagsModified,
  postPQDashboard,
  addTemplateGroup,
  addTemplate,
  postalarm,
  getdevicetagsModifiedconfig,
} from "../../Restclient/datacollection";
import { set } from "date-fns";

// Helper to get tag display string for alerts/reports (for use in AlertsConfigSection and ReportsConfigSection)
function getTagDisplayModified(
  TagID,
  tagdetailsobject,
  devicedetailsobject,
  showAliasFlag,
  value,
) {
  const tagObj =
    tagdetailsobject && tagdetailsobject[TagID] ? tagdetailsobject[TagID] : "";
  if (!tagObj) return "";
  const deviceName =
    tagObj.DeviceID &&
    devicedetailsobject &&
    devicedetailsobject[tagObj.DeviceID]
      ? devicedetailsobject[tagObj.DeviceID].Name
      : "";
  const alias = tagObj.Alias ? tagObj.Alias : tagObj.Name ? "(No Alias)" : "";
  const name = tagObj.Name ? tagObj.Name : tagObj.Alias ? "(No Name)" : "";
  return `${deviceName}: ${showAliasFlag ? alias : name}`.trim();
}

// Lazy load the heavy dashboard component
const PowerQualityStandardDashboards = lazy(
  () => import("./PowerQualityStandardDashboards"),
);

// Memoized components to prevent unnecessary re-renders
const MemoizedTextField = React.memo(
  ({ field, value, onChange, onFocus, ...props }) => (
    <TextField
      key={field}
      fullWidth
      label=""
      value={value}
      variant="standard"
      {...props}
      onChange={onChange}
      onFocus={onFocus}
    />
  ),
);

const MemoizedGridItem = React.memo(({ children, ...props }) => (
  <Grid item {...props}>
    {children}
  </Grid>
));

// ...existing code...

// Memoized dialog content sections
const DashboardConfigSection = React.memo(
  ({
    dashboardConfig,
    themechange,
    handleInputHarmonicsNumber,
    setFocusedFieldKey,
    showAliasFlag,
    devicedetailsobject,
    tagdetailsobject,
  }) => {
    const textFieldSx = useMemo(
      () => ({
        "& .MuiInputBase-input:focus": {
          color: "#008CD7",
        },
        "& .MuiInputBase-root": {
          fontFamily: "Roboto",
          fontSize: "16px",
          fontWeight: "700",
          color: themechange === "light" ? "#3C3C3C" : "#FFFFFF",
        },
        "& .MuiInput-root .MuiInputBase-input": {},
        "& .MuiInputBase-root::before": {
          borderBottom: `1px solid ${themechange === "light" ? "#3C3C3C" : "#FFFFFF"}`,
        },
        "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
          borderBottom: "2px solid #008CD7",
        },
        "& .MuiInputBase-root::after": {
          borderBottom: "2px solid #008CD7",
        },
        marginBottom: "16px",
      }),
      [themechange],
    );

    function isValidLengthNew(value, minLength, maxLength) {
      return value.length >= minLength && value.length <= maxLength;
    }
    function containsSpacesOrSpecialChars(str) {
      // Allow spaces and underscores, but reject other special characters
      return /[^\w\s]/.test(str);
    }

    return (
      <>
        <Typography
          sx={{
            fontSize: "16px",
            fontFamily: "Roboto",
            color: themechange === "light" ? "#7e7e7e" : "#c1c1c1",
            fontWeight: 400,
            marginLeft: "0px",
            textAlign: "left",
            marginTop: "10px",
          }}
        >
          Dashboard Name
        </Typography>
        <MemoizedTextField
          field="dashboardName"
          value={dashboardConfig.noOfHarmonics["dashboardName"].value}
          sx={textFieldSx}
          onChange={(e) =>
            handleInputHarmonicsNumber(
              0,
              dashboardConfig.noOfHarmonics["dashboardName"].name,
              e.target.value,
            )
          }
          placeholder="Enter Dashboard Name - as per Plant View"
          required
          inputProps={{ minLength: 5, maxLength: 30 }}
          helperText={
            dashboardConfig.noOfHarmonics["dashboardName"].value.length > 0 &&
            (!isValidLengthNew(
              dashboardConfig.noOfHarmonics["dashboardName"].value,
              5,
              30,
            ) ||
              containsSpacesOrSpecialChars(
                dashboardConfig.noOfHarmonics["dashboardName"].value,
              ))
              ? `Length must be between 5 and 30 characters. Only letters, numbers, spaces, and underscores are allowed. ${dashboardConfig.noOfHarmonics["dashboardName"].value.length}/30 characters used`
              : `${dashboardConfig.noOfHarmonics["dashboardName"].value.length}/30 characters used`
          }
          FormHelperTextProps={{
            sx: {
              color:
                dashboardConfig.noOfHarmonics["dashboardName"].value.length >
                  0 &&
                (!isValidLengthNew(
                  dashboardConfig.noOfHarmonics["dashboardName"].value,
                  5,
                  30,
                ) ||
                  containsSpacesOrSpecialChars(
                    dashboardConfig.noOfHarmonics["dashboardName"].value,
                  ))
                  ? "#DC272D"
                  : "#00943D",
            },
          }}
        />

        <Typography
          sx={{
            fontSize: "16px",
            fontFamily: "Roboto",
            color: themechange === "light" ? "#7e7e7e" : "#c1c1c1",
            fontWeight: 400,
            marginLeft: "0px",
            textAlign: "left",
            marginTop: "10px",
          }}
        >
          Power Factor
        </Typography>
        <MemoizedTextField
          field="powerFactor"
          //value={dashboardConfig.powerFactor.powerFactor.value}
          value={getTagDisplayModified(
            dashboardConfig.powerFactor.powerFactor.tagid,
            tagdetailsobject,
            devicedetailsobject,
            showAliasFlag,
            dashboardConfig.powerFactor.powerFactor.value,
          )}
          sx={textFieldSx}
          onFocus={() => setFocusedFieldKey("powerFactor.powerFactor")}
          readOnly
          placeholder="Click to select a tag"
        />

        <Typography
          sx={{
            fontSize: "16px",
            fontFamily: "Roboto",
            color: themechange === "light" ? "#7e7e7e" : "#c1c1c1",
            fontWeight: 400,
            marginLeft: "0px",
            textAlign: "left",
            marginTop: "10px",
          }}
        >
          PQ Events
        </Typography>
        <Grid container spacing={2}>
          {Object.keys(dashboardConfig.pqEvents).map((event) => (
            <MemoizedGridItem item xs={4} key={event}>
              <Typography
                sx={{
                  fontSize: "16px",
                  fontFamily: "Roboto",
                  color: themechange === "light" ? "#7e7e7e" : "#c1c1c1",
                  fontWeight: 400,
                  marginLeft: "0px",
                  textAlign: "left",
                  marginTop: "10px",
                }}
              >
                {dashboardConfig.pqEvents[event].name}
              </Typography>
              <MemoizedTextField
                field={event}
                //value={dashboardConfig.pqEvents[event].value}
                value={getTagDisplayModified(
                  dashboardConfig.pqEvents[event].tagid,
                  tagdetailsobject,
                  devicedetailsobject,
                  showAliasFlag,
                  dashboardConfig.pqEvents[event].value,
                )}
                sx={textFieldSx}
                onFocus={() => setFocusedFieldKey("pqEvents." + event)}
                readOnly
                placeholder="Click to select a tag"
              />
            </MemoizedGridItem>
          ))}
        </Grid>
      </>
    );
  },
);

const VoltageUnbalanceSection = React.memo(
  ({
    dashboardConfig,
    themechange,
    setFocusedFieldKey,
    showAliasFlag,
    devicedetailsobject,
    tagdetailsobject,
  }) => {
    const textFieldSx = useMemo(
      () => ({
        "& .MuiInputBase-input:focus": {
          color: "#008CD7",
        },
        "& .MuiInputBase-root": {
          fontFamily: "Roboto",
          fontSize: "16px",
          fontWeight: "700",
          color: themechange === "light" ? "#3C3C3C" : "#FFFFFF",
        },
        "& .MuiInput-root .MuiInputBase-input": {},
        "& .MuiInputBase-root::before": {
          borderBottom: `1px solid ${themechange === "light" ? "#3C3C3C" : "#FFFFFF"}`,
        },
        "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
          borderBottom: "2px solid #008CD7",
        },
        "& .MuiInputBase-root::after": {
          borderBottom: "2px solid #008CD7",
        },
        marginBottom: "16px",
      }),
      [themechange],
    );

    return (
      <>
        <Typography
          sx={{
            fontSize: "16px",
            fontFamily: "Roboto",
            color: themechange === "light" ? "#7e7e7e" : "#c1c1c1",
            fontWeight: 400,
            marginLeft: "0px",
            textAlign: "left",
            marginTop: "10px",
          }}
        >
          Voltage Unbalance
        </Typography>
        <Grid container spacing={2}>
          {Object.keys(dashboardConfig.voltageUnbalance).map((phase) => (
            <MemoizedGridItem item xs={4} key={phase}>
              <Typography
                sx={{
                  fontSize: "16px",
                  fontFamily: "Roboto",
                  color: themechange === "light" ? "#7e7e7e" : "#c1c1c1",
                  fontWeight: 400,
                  marginLeft: "0px",
                  textAlign: "left",
                  marginTop: "10px",
                }}
              >
                {dashboardConfig.voltageUnbalance[phase].name}
              </Typography>
              <MemoizedTextField
                field={phase}
                onKeyDown={(e) => e.preventDefault()}
                //value={dashboardConfig.voltageUnbalance[phase].value}
                value={getTagDisplayModified(
                  dashboardConfig.voltageUnbalance[phase].tagid,
                  tagdetailsobject,
                  devicedetailsobject,
                  showAliasFlag,
                  dashboardConfig.voltageUnbalance[phase].value,
                )}
                sx={textFieldSx}
                onFocus={() => setFocusedFieldKey("voltageUnbalance." + phase)}
                readOnly
                placeholder="Click to select a tag"
              />
            </MemoizedGridItem>
          ))}
        </Grid>
      </>
    );
  },
);

const CurrentUnbalanceSection = React.memo(
  ({
    dashboardConfig,
    themechange,
    setFocusedFieldKey,
    showAliasFlag,
    devicedetailsobject,
    tagdetailsobject,
  }) => {
    const textFieldSx = useMemo(
      () => ({
        "& .MuiInputBase-input:focus": {
          color: "#008CD7",
        },
        "& .MuiInputBase-root": {
          fontFamily: "Roboto",
          fontSize: "16px",
          fontWeight: "700",
          color: themechange === "light" ? "#3C3C3C" : "#FFFFFF",
        },
        "& .MuiInput-root .MuiInputBase-input": {},
        "& .MuiInputBase-root::before": {
          borderBottom: `1px solid ${themechange === "light" ? "#3C3C3C" : "#FFFFFF"}`,
        },
        "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
          borderBottom: "2px solid #008CD7",
        },
        "& .MuiInputBase-root::after": {
          borderBottom: "2px solid #008CD7",
        },
        marginBottom: "16px",
      }),
      [themechange],
    );

    return (
      <>
        <Typography
          sx={{
            fontSize: "16px",
            fontFamily: "Roboto",
            color: themechange === "light" ? "#7e7e7e" : "#c1c1c1",
            fontWeight: 400,
            marginLeft: "0px",
            textAlign: "left",
            marginTop: "10px",
          }}
        >
          Current Unbalance
        </Typography>
        <Grid container spacing={2}>
          {Object.keys(dashboardConfig.currentUnbalance).map((phase) => (
            <MemoizedGridItem item xs={4} key={phase}>
              <Typography
                sx={{
                  fontSize: "16px",
                  fontFamily: "Roboto",
                  color: themechange === "light" ? "#7e7e7e" : "#c1c1c1",
                  fontWeight: 400,
                  marginLeft: "0px",
                  textAlign: "left",
                  marginTop: "10px",
                }}
              >
                {dashboardConfig.currentUnbalance[phase].name}
              </Typography>
              <MemoizedTextField
                field={phase}
                onKeyDown={(e) => e.preventDefault()}
                //value={dashboardConfig.currentUnbalance[phase].value}
                value={getTagDisplayModified(
                  dashboardConfig.currentUnbalance[phase].tagid,
                  tagdetailsobject,
                  devicedetailsobject,
                  showAliasFlag,
                  dashboardConfig.currentUnbalance[phase].value,
                )}
                sx={textFieldSx}
                onFocus={() => setFocusedFieldKey("currentUnbalance." + phase)}
                readOnly
                placeholder="Click to select a tag"
              />
            </MemoizedGridItem>
          ))}
        </Grid>
      </>
    );
  },
);

// Virtualized harmonics section to handle large lists efficiently
const HarmonicsSection = React.memo(
  ({
    title,
    harmonics,
    dashboardConfig,
    themechange,
    setFocusedFieldKey,
    fieldKey,
    showAliasFlag,
    devicedetailsobject,
    tagdetailsobject,
  }) => {
    const [visibleRange, setVisibleRange] = useState({ start: 0, end: 10 });
    const [showAll, setShowAll] = useState(false);

    const textFieldSx = useMemo(
      () => ({
        "& .MuiInputBase-input:focus": {
          color: "#008CD7",
        },
        "& .MuiInputBase-root": {
          fontFamily: "Roboto",
          fontSize: "16px",
          fontWeight: "700",
          color: themechange === "light" ? "#3C3C3C" : "#FFFFFF",
        },
        "& .MuiInput-root .MuiInputBase-input": {},
        "& .MuiInputBase-root::before": {
          borderBottom: `1px solid ${themechange === "light" ? "#3C3C3C" : "#FFFFFF"}`,
        },
        "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
          borderBottom: "2px solid #008CD7",
        },
        "& .MuiInputBase-root::after": {
          borderBottom: "2px solid #008CD7",
        },
        marginBottom: "16px",
      }),
      [themechange],
    );

    const visibleHarmonics = useMemo(() => {
      return showAll
        ? harmonics
        : harmonics.slice(visibleRange.start, visibleRange.end);
    }, [harmonics, visibleRange, showAll]);

    const loadMore = useCallback(() => {
      if (visibleRange.end < harmonics.length) {
        setVisibleRange((prev) => ({
          start: prev.start,
          end: Math.min(prev.end + 10, harmonics.length),
        }));
      } else {
        setShowAll(true);
      }
    }, [harmonics.length, visibleRange.end]);

    return (
      <>
        <Typography
          sx={{
            fontSize: "16px",
            fontFamily: "Roboto",
            color: themechange === "light" ? "#7e7e7e" : "#c1c1c1",
            fontWeight: 400,
            marginLeft: "0px",
            textAlign: "left",
            marginTop: "10px",
          }}
        >
          {title}
        </Typography>
        {visibleHarmonics.map((harmonic, index) => {
          const actualIndex = showAll ? index : visibleRange.start + index;
          return (
            <Grid container spacing={2} key={actualIndex}>
              {Object.keys(harmonic).map((phase) => (
                <MemoizedGridItem item xs={4} key={phase}>
                  <MemoizedTextField
                    field={`${fieldKey}-${actualIndex}-${phase}`}
                    onKeyDown={(e) => e.preventDefault()}
                    //value={harmonic[phase].value}
                    value={getTagDisplayModified(
                      harmonic[phase].tagid,
                      tagdetailsobject,
                      devicedetailsobject,
                      showAliasFlag,
                      harmonic[phase].value,
                    )}
                    label={harmonic[phase].name}
                    sx={textFieldSx}
                    onFocus={() =>
                      setFocusedFieldKey(`${fieldKey}[${actualIndex}].${phase}`)
                    }
                    readOnly
                    placeholder="Click to select a tag"
                  />
                </MemoizedGridItem>
              ))}
            </Grid>
          );
        })}
        {!showAll && visibleRange.end < harmonics.length && (
          <Button
            onClick={loadMore}
            sx={{
              mt: 2,
              mb: 2,
              backgroundColor: "#005C8E",
              color: "white",
              "&:hover": {
                backgroundColor: "#004A73",
              },
            }}
          >
            Load More ({harmonics.length - visibleRange.end} remaining)
          </Button>
        )}
      </>
    );
  },
);

// Memoized alerts configuration section
const AlertsConfigSection = React.memo(
  ({
    themechange,
    alertRules,
    selectedAlertIndexes,
    handleAlertCheckboxChange,
    handleSaveSelectedAlerts,
    handleCloseGoToDashboard,
    showAliasFlag,
    devicedetailsobject,
    tagdetailsobject,
  }) => (
    <Box sx={{ width: "100%" }}>
      <div style={{ display: "flex", flexDirection: "row" }}>
        <Typography
          sx={{
            fontSize: "16px",
            fontFamily: "Roboto",
            color: themechange === "light" ? "#7e7e7e" : "#c1c1c1",
            fontWeight: 400,
            marginLeft: "0px",
            textAlign: "left",
            marginTop: "10px",
          }}
        >
          Alert Rules
        </Typography>
        <div style={{ flexGrow: 1 }}></div>
        <CustomCancelButton
          onClick={handleCloseGoToDashboard}
          buttonText={"Go to Dashboard"}
        />
      </div>
      <Box sx={{ mt: 2, border: "1px solid #008CD7", padding: 2 }}>
        {alertRules.length === 0 ? (
          <Typography>No alert rules generated.</Typography>
        ) : (
          <ul
            style={{
              listStyle: "none",
              padding: 0,
              maxHeight: "400px",
              overflowY: "auto",
            }}
            className="styled-scrollbar"
          >
            {console.log(
              "AlertsConfigSection alertRules",
              alertRules,
              "tagdetailsobject[rule.TagID]",
              tagdetailsobject,
            )}
            {alertRules.map((rule, idx) => (
              <li
                key={idx}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "baseline",
                  marginBottom: 0,
                  gap: 5,
                }}
              >
                <Checkbox
                  checkedIcon={<CheckBoxOutlinedIcon sx={{ marginTop: 0 }} />}
                  style={{
                    color: themechange === "light" ? "#7e7e7e" : "#c1c1c1",
                  }}
                  sx={{
                    padding: 0,
                    marginRight: 0,
                    color: "#008cd7",
                    "& .MuiSvgIcon-root": {
                      fontSize: "20px",
                      color: "#008cd7",
                    },
                  }}
                  checked={selectedAlertIndexes.includes(idx)}
                  onChange={() => handleAlertCheckboxChange(idx)}
                />
                <Typography
                  sx={{
                    fontSize: "16px",
                    fontFamily: "Roboto",
                    color: themechange === "light" ? "#7e7e7e" : "#c1c1c1",
                    paddingBottom: 8,
                    fontWeight: 400,
                    marginLeft: "0px",
                    marginTop: 0,
                    textAlign: "left",
                    marginBottom: 5,
                  }}
                >
                  {rule.Alert_rule_name
                    ? `${rule.Alert_rule_name}:` +
                      getTagDisplayModified(
                        rule.TagID,
                        tagdetailsobject,
                        devicedetailsobject,
                        showAliasFlag,
                        "",
                      ) +
                      `  Alert Condition ${rule.conditions[0].condition || ""} ${rule.conditions[0].value.alarm_condition_lower || ""}`
                    : ""}
                </Typography>
              </li>
            ))}
          </ul>
        )}
        <CustomButton
          disabled={selectedAlertIndexes.length === 0}
          onClick={handleSaveSelectedAlerts}
          buttonText={"Save Selected Alerts"}
        />
      </Box>
    </Box>
  ),
);

// Memoized reports configuration section
const ReportsConfigSection = React.memo(
  ({
    themechange,
    groupCreated,
    dashboardLinked,
    templateCreated,
    tagObjects,
    selectedReportTagObjects,
    handleReportTagCheckboxChange,
    handleAddReportGroup,
    handleAddReportTemplate,
    handleDashboardReportGroup,
    handleCloseGoToDashboard,
    showAliasFlag,
    devicedetailsobject,
    tagdetailsobject,
  }) => (
    <Box sx={{ width: "100%" }}>
      <div style={{ display: "flex", flexDirection: "row" }}>
        <Typography
          sx={{
            fontSize: "16px",
            fontFamily: "Roboto",
            color: themechange === "light" ? "#7e7e7e" : "#c1c1c1",
            fontWeight: 400,
            marginLeft: "0px",
            textAlign: "left",
            marginTop: "10px",
          }}
        >
          Report Rules
        </Typography>
        <div style={{ flexGrow: 1 }}></div>
        {console.log(
          "ReportsConfigSection selectedReportTagObjects tagObjects",
          tagObjects,
        )}
        <CustomCancelButton
          onClick={handleCloseGoToDashboard}
          buttonText={"Go to Dashboard"}
        />
      </div>
      <Typography
        sx={{
          fontSize: "16px",
          fontFamily: "Roboto",
          color: themechange === "light" ? "#7e7e7e" : "#c1c1c1",
          fontWeight: 400,
          marginLeft: "0px",
          textAlign: "left",
          marginTop: "10px",
        }}
      >
        Step 1:
      </Typography>
      <Typography
        sx={{
          fontSize: "16px",
          fontFamily: "Roboto",
          color: themechange === "light" ? "#7e7e7e" : "#c1c1c1",
          fontWeight: 400,
          marginLeft: "0px",
          textAlign: "left",
          marginTop: "10px",
        }}
      >
        {groupCreated}
      </Typography>
      <CustomButton
        buttonText={"Create Standard Template Group"}
        onClick={handleAddReportGroup}
      />
      <Box sx={{ mt: 4 }}>
        <Typography
          sx={{
            fontSize: "16px",
            fontFamily: "Roboto",
            color: themechange === "light" ? "#7e7e7e" : "#c1c1c1",
            fontWeight: 400,
            marginLeft: "0px",
            textAlign: "left",
            marginTop: "10px",
          }}
        >
          Step 2:
        </Typography>
        <Typography
          sx={{
            fontSize: "16px",
            fontFamily: "Roboto",
            color: themechange === "light" ? "#7e7e7e" : "#c1c1c1",
            fontWeight: 400,
            marginLeft: "0px",
            textAlign: "left",
            marginTop: "10px",
          }}
        >
          {templateCreated}
        </Typography>
        {tagObjects.length === 0 ? (
          <Typography
            sx={{
              fontSize: "16px",
              fontFamily: "Roboto",
              color: themechange === "light" ? "#7e7e7e" : "#c1c1c1",
              fontWeight: 400,
              marginLeft: "0px",
              textAlign: "left",
              marginTop: "10px",
            }}
          >
            No tags configured for reports.
          </Typography>
        ) : (
          <ul
            style={{
              listStyle: "none",
              padding: 0,
              maxHeight: "300px",
              overflowY: "auto",
            }}
          >
            {tagObjects.map(
              (tag, idx) =>
                tag.StorageEnabled &&
                (tag.StorageEnabled == true || tag.StorageEnabled == "true") &&
                Array.isArray(tag.StorageID) &&
                tag.StorageID.length > 0 && (
                  <li
                    key={tag.tagid || idx}
                    style={{
                      display: "flex",
                      alignItems: "baseline",
                      marginBottom: 8,
                      gap: 5,
                    }}
                  >
                    <Checkbox
                      checkedIcon={
                        <CheckBoxOutlinedIcon sx={{ marginTop: 0 }} />
                      }
                      style={{
                        color: themechange === "light" ? "#7e7e7e" : "#c1c1c1",
                      }}
                      sx={{
                        padding: 0,
                        marginRight: 0,
                        color: "#008cd7",
                        "& .MuiSvgIcon-root": {
                          fontSize: "20px",
                          color: "#008cd7",
                        },
                      }}
                      checked={selectedReportTagObjects.some(
                        (t) => t.TagID === tag.TagID,
                      )}
                      onChange={() => handleReportTagCheckboxChange(idx)}
                    />
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontFamily: "Roboto",
                        color: themechange === "light" ? "#7e7e7e" : "#c1c1c1",
                        paddingBottom: 8,
                        fontWeight: 400,
                        marginLeft: "0px",
                        marginTop: 0,
                        textAlign: "left",
                        marginBottom: 5,
                      }}
                    >
                      {getTagDisplayModified(
                        tag.TagID,
                        tagdetailsobject,
                        devicedetailsobject,
                        showAliasFlag,
                        "",
                      )}
                    </Typography>
                  </li>
                ),
            )}
          </ul>
        )}
        <CustomButton
          buttonText={"Create Standard Template"}
          onClick={handleAddReportTemplate}
        />
      </Box>
      <Box sx={{ mt: 4 }}>
        <Typography
          sx={{
            fontSize: "16px",
            fontFamily: "Roboto",
            color: themechange === "light" ? "#7e7e7e" : "#c1c1c1",
            fontWeight: 400,
            marginLeft: "0px",
            textAlign: "left",
            marginTop: "10px",
          }}
        >
          Step 3:
        </Typography>
        <Typography
          sx={{
            fontSize: "16px",
            fontFamily: "Roboto",
            color: themechange === "light" ? "#7e7e7e" : "#c1c1c1",
            fontWeight: 400,
            marginLeft: "0px",
            textAlign: "left",
            marginTop: "10px",
          }}
        >
          {dashboardLinked}
        </Typography>
        <CustomButton
          buttonText={"Link Dashboard"}
          onClick={handleDashboardReportGroup}
        />
      </Box>
    </Box>
  ),
);

const CustomSubheading = ({ children }) => {
  return (
    <Typography
      className="config-compliance-subheading"
      style={{
        fontSize: "18px",
        fontWeight: 400,
        color: "var(--SecondaryText)",
      }}
    >
      {children}
    </Typography>
  );
};

export default function PowerQualityConfiguration() {
  // Dialog state for duplicate tag assignment
  const [duplicateTagDialogOpen, setDuplicateTagDialogOpen] = useState(false);
  const [duplicateTagDialogMsg, setDuplicateTagDialogMsg] = useState("");
  const duplicateDialogBlockRef = React.useRef(false);

  // ...existing code...
  // Helper to get tag display string (now inside component)
  const getTagDisplay = (tagid, value) => {
    const tagObj = tagdetailsobject && tagdetailsobject[tagid];
    const deviceName =
      tagObj &&
      tagObj.DeviceID &&
      devicedetailsobject &&
      devicedetailsobject[tagObj.DeviceID]
        ? devicedetailsobject[tagObj.DeviceID].Name
        : "";
    const alias =
      tagObj && tagObj.Alias ? tagObj.Alias : value !== "" ? "(No Alias)" : "";
    const name =
      tagObj && tagObj.Name ? tagObj.Name : value !== "" ? "(No Name)" : "";
    if (!tagid) return "Select tag";
    return `${deviceName}: ${showAliasFlag ? alias : name}` || "Select tag";
  };
  const themechange = useSelector((state) => state.themedata.theme);
  const [pagesize, setPagesize] = useState(370);
  const overviewstate = useSelector(
    (state) => state.mainpagedata.overviewbarstate,
  );
  const userdetails = useSelector((state) => state.logindata.userdetails);
  const username = useSelector((state) => state.logindata.username);
  const [conditions, setConditions] = useState([
    {
      voltage_config_id: "",
      enable: false,
      pcclowerlimit: "",
      sign: "",
      pccupperlimit: "",
      individualharmonics: [],
      thdthreshold: "",
    },
  ]);
  const [invalidLimits, setInValidLimits] = useState(false);
  const [invalidLimitsLowerUpper, setInValidLimitsLowerUpper] = useState(false);
  const logindetails = useSelector((state) => state.logindata.userdetails);
  const projectId = useSelector(
    (state) => state.mainpagedata.selectedprojectname,
  );
  const [mainconditions, setMainConditions] = useState([
    {
      current_config_id: "",
      enable: false,
      pcclowerlimit: "",
      sign: "",
      pccupperlimit: "",
      isc_il_ratio_lower_limit: "",
      isc_il_sign: "",
      isc_il_ratio_upper_limit: "",
      individualharmonics: [],
      tddthreshold: "",
    },
  ]);
  const [openAtLeastOneConditionDialog, setopenAtLeastOneConditionDialog] =
    useState(false);
  const [isVoltageChecked, setIsVoltageChecked] = useState(false);
  const [isCurrentChecked, setIsCurrentChecked] = useState(false);
  const [opensave, setOpenSave] = useState(false);
  const [openAlarmUpdatedandSaved, setopenAlarmUpdatedandSaved] =
    useState(false);
  const [openDuplicateAlarm, setopenDuplicateAlarm] = useState(false);
  const [deletevoltageConfirmation, setDeleteVoltageConfirmation] =
    useState(false);
  const [deletecurrentConfirmation, setDeletecurrentConfirmation] =
    useState(false);
  const [deleteCurrentIndex, setDeleteCurrentIndex] = useState("");
  const [deleteVoltageIndex, setDeleteVoltageIndex] = useState("");
  const [saveddata, setSavedData] = useState(false);
  const [alertRules, setAlertRules] = useState([]);
  const [tagObjects, setTagObjects] = useState([]);
  const [selectedAlertIndexes, setSelectedAlertIndexes] = useState([]);
  const [selectedReportTagObjects, setSelectedReportTagObjects] = useState([]);
  const [reportTemplates, setReportTemplates] = useState([]);
  const [groupCreated, setGroupCreated] = useState("");
  const [templateCreated, setTemplateCreated] = useState("");
  const [dashboardLinked, setDashboardLinked] = useState("");
  const [enablefetchData, setEnablefetchData] = useState(false);
  const [fetchdataConfirm, setfetchdataConfirm] = useState(false);
  const [notFetchedPQData, setNotFetchedPQData] = useState(false);
  const [notGetPQData, setNotGetPQData] = useState(false);
  const projectname = useSelector(
    (state) => state.mainpagedata.selectedprojectname,
  );
  const [openDialogIndex, setOpenDialogIndex] = useState(null);
  const [openDialogCurrentHarmonicIndex, setOpenDialogCurrentHarmonicIndex] =
    useState(null);
  const [openDashboardDialog, setOpenDashboardDialog] = useState(false);
  const [assetdata, setAssetData] = useState(null);
  const [existingDeviceTagAlarmConfig, setExistingDeviceTagAlarmConfig] =
    useState(false);
  const [selectedTag, setSelectedTag] = useState({
    tagid: "",
    tagname: "",
    tagunit: "",
    std_tagname: "",
    tagdatatype: "",
    projectid: "",
  });
  const [selectedAsset, setSelectedAsset] = useState({
    asset_name: "",
    device_id: "",
  });
  const [focusedFieldKey, setFocusedFieldKey] = useState(null);
  const [viewDashboard, setViewDashboard] = useState(false);
  const [isPending, startTransition] = useTransition();
  const [createdSucess, setCreatedSuccess] = useState(false);
  const [notCreatedSuccess, setNotCreatedSuccess] = useState(false);
  const [notCreatedMessage, setNotCreatedMessage] = useState("");
  const [dashboardList, setDashboardList] = useState([]);
  const [dashboardPro, setDashboardPro] = useState("");
  const [groupid, setGroupid] = useState("");
  const [showAliasFlag, setShowAliasFlag] = useState(true);

  // Frontend Component State
  const [isSaving, setIsSaving] = useState(false);
  const [saveProgress, setSaveProgress] = useState({
    total: 0,
    current: 0,
    completed: 0,
    failed: 0,
    currentAlertName: "",
    results: [],
  });
  // Add loading state for dialog content
  const [dialogContentLoading, setDialogContentLoading] = useState(false);

  const [thresholds, setThresholds] = useState({
    overVoltageThreshold: {
      name: "Over Voltage Threshold (V)",
      value: "",
      tagid: "",
    },
    underVoltageThreshold: {
      name: "Under Voltage Threshold (V)",
      value: "",
      tagid: "",
    },
    overCurrentThreshold: {
      name: "Over Current Threshold (A)",
      value: "",
      tagid: "",
    },
    underCurrentThreshold: {
      name: "Under Current Threshold (A)",
      value: "",
      tagid: "",
    },
  });
  const tagdetailsobject = useSelector(
    (state) => state.mainpagedata.tagdetailsobject,
  );
  const devicedetailsobject = useSelector(
    (state) => state.mainpagedata.devicedetailsobject,
  );
  const [configAlerts, setConfigAlerts] = useState(false);
  const [configReports, setConfigReports] = useState(false);
  const [deleteCurrentHarmonicsFailed, setCurrentHarmonicsFailed] =
    useState(false);
  const [deleteCurrentHarmonicsSuccess, setCurrentHarmonicsSuccess] =
    useState(false);
  const [deleteVoltageHarmonicsFailed, setVoltageHarmonicsFailed] =
    useState(false);
  const [deleteVoltageHarmonicsSuccess, setVoltageHarmonicsSuccess] =
    useState(false);

  // Memoize the initial dashboard config to prevent recreation on every render
  const initialDashboardConfig = useMemo(
    () => ({
      powerFactor: {
        powerFactor: { name: "Power Factor", value: "", tagid: "" },
      },
      noOfHarmonics: {
        dashboardName: { name: "Dashboard Name", value: "", tagid: "" },
        noOfVoltageHarmonics: {
          name: "No of Voltage Harmonics",
          value: 0,
          tagid: "",
        },
        noOfCurrentHarmonics: {
          name: "No of Current Harmonics",
          value: 0,
          tagid: "",
        },
      },
      pqEvents: {
        underVoltage: { name: "Under Voltage", value: "", tagid: "" },
        overVoltage: { name: "Over Voltage", value: "", tagid: "" },
        sags: { name: "Sags", value: "", tagid: "" },
        swells: { name: "Swells", value: "", tagid: "" },
        interruptions: { name: "Interruptions", value: "", tagid: "" },
      },
      voltageUnbalance: {
        rPhase: { name: "R Phase Voltage Unbalance", value: "", tagid: "" },
        yPhase: { name: "Y Phase Voltage Unbalance", value: "", tagid: "" },
        bPhase: { name: "B Phase Voltage Unbalance", value: "", tagid: "" },
      },
      currentUnbalance: {
        rPhase: { name: "R Phase Current Unbalance", value: "", tagid: "" },
        yPhase: { name: "Y Phase Current Unbalance", value: "", tagid: "" },
        bPhase: { name: "B Phase Current Unbalance", value: "", tagid: "" },
      },
      individualCurrentHarmonics: Array.from({ length: 63 }, (_, i) => ({
        rPhase: {
          name: `R Phase Current ${i + 1}th Harmonic`,
          value: "",
          tagid: "",
        },
        yPhase: {
          name: `Y Phase Current ${i + 1}th Harmonic`,
          value: "",
          tagid: "",
        },
        bPhase: {
          name: `B Phase Current ${i + 1}th Harmonic`,
          value: "",
          tagid: "",
        },
      })),
      individualVoltageHarmonics: Array.from({ length: 63 }, (_, i) => ({
        rPhase: {
          name: `R Phase Voltage ${i + 1}th Harmonic`,
          value: "",
          tagid: "",
        },
        yPhase: {
          name: `Y Phase Voltage ${i + 1}th Harmonic`,
          value: "",
          tagid: "",
        },
        bPhase: {
          name: `B Phase Voltage ${i + 1}th Harmonic`,
          value: "",
          tagid: "",
        },
      })),
      totalDemandDistortion: {
        tdd: { name: "Total Demand Distortion", value: "", tagid: "" },
      },
      voltage: {
        voltage: { name: "R Phase Voltage", value: "", tagid: "" },
      },
      voltageTotalHarmonicDistortion: {
        rPhase: {
          name: "R Phase Voltage Total Harmonic Distortion",
          value: "",
          tagid: "",
        },
        yPhase: {
          name: "Y Phase Voltage Total Harmonic Distortion",
          value: "",
          tagid: "",
        },
        bPhase: {
          name: "B Phase Voltage Total Harmonic Distortion",
          value: "",
          tagid: "",
        },
      },
      currentTotalHarmonicDistortion: {
        rPhase: {
          name: "R Phase Current Total Harmonic Distortion",
          value: "",
          tagid: "",
        },
        yPhase: {
          name: "Y Phase Current Total Harmonic Distortion",
          value: "",
          tagid: "",
        },
        bPhase: {
          name: "B Phase Current Total Harmonic Distortion",
          value: "",
          tagid: "",
        },
      },
    }),
    [],
  );

  const [dashboardConfig, setDashboardConfig] = useState(
    initialDashboardConfig,
  );
  const [openAlertRuleNameExceedsLength, setopenAlertRuleNameExceedsLength] =
    useState(false);
  function isValidLengthNew(value, minLength, maxLength) {
    return value.length >= minLength && value.length <= maxLength;
  }
  function containsSpacesOrSpecialChars(str) {
    // Allow spaces and underscores, but reject other special characters
    return /[^\w\s]/.test(str);
  }

  function handleAlertRuleNameExceedsLength() {
    setopenAlertRuleNameExceedsLength(false);
  }
  // Memoize expensive computations
  const getMergedAlertRules = useCallback(
    (conditions, mainconditions, dashboardConfig) => {
      const alertRules = [];
      let currentTagObjects = [];
      let projectID = "";
      if (userdetails && userdetails.Projectid && userdetails.Organizationid) {
        if (userdetails && userdetails?.Projectid == "All") {
          projectID = projectname;
        } else {
          projectID = userdetails.Projectid;
        }
      }

      // Voltage Harmonics
      const enabledVoltageRows = conditions.filter((row) => row.enable);
      //const enabledVoltageRows = conditions;
      // Current Harmonics
      const enabledCurrentRows = mainconditions.filter((row) => row.enable);
      //const enabledCurrentRows = mainconditions;
      const tddTagObjPF = dashboardConfig.powerFactor.powerFactor;

      console.log(
        "getMergedAlertRules enabledVoltageRows",
        enabledVoltageRows,
        "getMergedAlertRules enabledCurrentRows",
        enabledCurrentRows,
        "tddTagObjPF",
        tddTagObjPF,
        "dashboardConfig",
        dashboardConfig,
      );
      console.log("Merged Alert Rules: 123", enabledVoltageRows);
      enabledVoltageRows.forEach((row) => {
        row.individualharmonics.forEach((harmonic, idx) => {
          ["rPhase", "yPhase", "bPhase"].forEach((phase) => {
            const tagObj =
              dashboardConfig.individualVoltageHarmonics[idx][phase];
            if (tagObj.tagid && harmonic.default_threshold !== undefined) {
              const TagDetails = tagdetailsobject[tagObj.tagid];
              const Alias = TagDetails ? TagDetails.Alias : "";
              const DeviceID = tagdetailsobject[tagObj.tagid]?.DeviceID || "";
              alertRules.push({
                Alert_rule_name: `${Alias}AlertRule`.replace(/\s+/g, ""),
                TagID: tagObj.tagid,
                DeviceID: DeviceID,
                enableAlert: true,
                SendMessage: true,
                SendEmail: true,
                ProjectID: projectID,
                conditions: [
                  {
                    condition: ">=",
                    alarmpriority: "Medium",
                    normalmessage: `${Alias} AlertRule Normal`,
                    abnormalmessage: `${Alias} AlertRule Abnormal`,
                    type: "Conditional",
                    value: {
                      alarm_condition_lower: harmonic.default_threshold,
                      alarm_condition_upper: "INF",
                    },
                  },
                ],
              });
              console.log(
                "getMergedAlertRules tagObj.tagid",
                tagObj.tagid,
                "tagdetailsobject[tagObj.tagid]",
                tagdetailsobject[tagObj.tagid],
              );
              currentTagObjects.push(tagdetailsobject[tagObj.tagid]);
            }
          });
        });

        // Add voltageTotalHarmonicDistortion for enabled voltage row
        ["rPhase", "yPhase", "bPhase"].forEach((phase) => {
          const thdTagObj =
            dashboardConfig.voltageTotalHarmonicDistortion[phase];
          if (
            thdTagObj.tagid &&
            row.thdthreshold !== undefined &&
            row.thdthreshold !== ""
          ) {
            const TagDetails = tagdetailsobject[thdTagObj.tagid];
            const Alias = TagDetails ? TagDetails.Alias : "";
            const DeviceID = tagdetailsobject[thdTagObj.tagid]?.DeviceID || "";
            alertRules.push({
              Alert_rule_name: `${Alias}AlertRule`.replace(/\s+/g, ""),
              TagID: thdTagObj.tagid,
              DeviceID: DeviceID,
              enableAlert: true,
              SendMessage: true,
              SendEmail: true,
              ProjectID: projectID,
              conditions: [
                {
                  condition: ">=",
                  alarmpriority: "Medium",
                  normalmessage: `${Alias} AlertRule Normal`,
                  abnormalmessage: `${Alias} AlertRule Abnormal`,
                  type: "Conditional",
                  value: {
                    alarm_condition_lower: row.thdthreshold,
                    alarm_condition_upper: "INF",
                  },
                },
              ],
            });
            console.log(
              "getMergedAlertRules thdTagObj.tagid",
              thdTagObj.tagid,
              "tagdetailsobject[thdTagObj.tagid]",
              tagdetailsobject[thdTagObj.tagid],
            );
            currentTagObjects.push(tagdetailsobject[thdTagObj.tagid]);
          }
        });
      });

      enabledCurrentRows.forEach((row) => {
        row.individualharmonics.forEach((harmonic, idx) => {
          ["rPhase", "yPhase", "bPhase"].forEach((phase) => {
            const tagObj =
              dashboardConfig.individualCurrentHarmonics[idx][phase];
            if (tagObj.tagid && harmonic.default_threshold !== undefined) {
              const TagDetails = tagdetailsobject[tagObj.tagid];
              const Alias = TagDetails ? TagDetails.Alias : "";
              const DeviceID = tagdetailsobject[tagObj.tagid]?.DeviceID || "";
              alertRules.push({
                Alert_rule_name: `${Alias}AlertRule`.replace(/\s+/g, ""),
                TagID: tagObj.tagid,
                DeviceID: DeviceID,
                enableAlert: true,
                SendMessage: true,
                SendEmail: true,
                ProjectID: projectID,
                conditions: [
                  {
                    condition: ">=",
                    alarmpriority: "Medium",
                    normalmessage: `${Alias} AlertRule Normal`,
                    abnormalmessage: `${Alias} AlertRule Abnormal`,
                    type: "Conditional",
                    value: {
                      alarm_condition_lower: harmonic.default_threshold,
                      alarm_condition_upper: "INF",
                    },
                  },
                ],
              });
              console.log(
                "getMergedAlertRules tagObj.tagid",
                tagObj.tagid,
                "tagdetailsobject[tagObj.tagid]",
                tagdetailsobject[tagObj.tagid],
              );
              currentTagObjects.push(tagdetailsobject[tagObj.tagid]);
            }
          });
        });

        // Add totalDemandDistortion for enabled voltage row
        const tddTagObj = dashboardConfig.totalDemandDistortion.tdd;
        if (
          tddTagObj.tagid &&
          row.tddthreshold !== undefined &&
          row.tddthreshold !== ""
        ) {
          const TagDetails = tagdetailsobject[tddTagObj.tagid];
          const Alias = TagDetails ? TagDetails.Alias : "";
          const DeviceID = tagdetailsobject[tddTagObj.tagid]?.DeviceID || "";
          alertRules.push({
            Alert_rule_name: `${Alias}AlertRule`.replace(/\s+/g, ""),
            TagID: tddTagObj.tagid,
            DeviceID: DeviceID,
            enableAlert: true,
            SendMessage: true,
            SendEmail: true,
            ProjectID: projectID,
            conditions: [
              {
                condition: ">=",
                alarmpriority: "Medium",
                normalmessage: `${Alias} AlertRule Normal`,
                abnormalmessage: `${Alias} AlertRule Abnormal`,
                type: "Conditional",
                value: {
                  alarm_condition_lower: row.tddthreshold,
                  alarm_condition_upper: "INF",
                },
              },
            ],
          });
          console.log(
            "getMergedAlertRules tddTagObj.tagid",
            tddTagObj.tagid,
            "tagdetailsobject[tddTagObj.tagid]",
            tagdetailsobject[tddTagObj.tagid],
          );
          currentTagObjects.push(tagdetailsobject[tddTagObj.tagid]);
        }
      });

      console.log("getMergedAlertRules tddTagObjPF", tddTagObjPF);
      if (tddTagObjPF.tagid) {
        const TagDetails = tagdetailsobject[tddTagObjPF.tagid];
        const Alias = TagDetails ? TagDetails.Alias : "";
        const DeviceID = tagdetailsobject[tddTagObjPF.tagid]?.DeviceID || "";
        alertRules.push({
          Alert_rule_name: `${Alias}AlertRule`.replace(/\s+/g, ""),
          TagID: tddTagObjPF.tagid,
          DeviceID: DeviceID,
          enableAlert: true,
          SendMessage: true,
          SendEmail: true,
          ProjectID: projectID,
          conditions: [
            {
              condition: ">=",
              alarmpriority: "Medium",
              normalmessage: `${Alias} AlertRule Normal`,
              abnormalmessage: `${Alias} AlertRule Abnormal`,
              type: "Conditional",
              value: {
                alarm_condition_lower: 0.8,
                alarm_condition_upper: "INF",
              },
            },
          ],
        });
        console.log(
          "getMergedAlertRules tddTagObjPF.tagid",
          tddTagObjPF.tagid,
          "tagdetailsobject[tddTagObjPF.tagid]",
          tagdetailsobject[tddTagObjPF.tagid],
        );
        currentTagObjects.push(tagdetailsobject[tddTagObjPF.tagid]);
      }
      console.log(
        "PowerQualityConfiguration currentTagObjects",
        currentTagObjects,
      );
      // Remove duplicate TagID entries
      // const uniqueTagObjects = Object.values(
      // currentTagObjects.reduce((acc, obj) => {
      //     acc[obj.TagID] = obj; // Only the last occurrence is kept
      //     return acc;
      // }, {})
      // );
      //setTagObjects(currentTagObjects);
      return alertRules;
    },
    [userdetails, projectname, tagdetailsobject, dashboardConfig],
  );

  // Helper to get tag display string for alerts/reports
  // function getTagDisplay(tagObj, devicedetailsobject, showAliasFlag) {
  //     if (!tagObj) return '';
  //     const deviceName = tagObj.DeviceID && devicedetailsobject && devicedetailsobject[tagObj.DeviceID] ? devicedetailsobject[tagObj.DeviceID].Name : '';
  //     const alias = tagObj.Alias ? tagObj.Alias : (tagObj.Name ? '(No Alias)' : '');
  //     const name = tagObj.Name ? tagObj.Name : (tagObj.Alias ? '(No Name)' : '');
  //     return `${deviceName}: ${showAliasFlag ? alias : name}`.trim();
  // }
  const getMergedReportRules = useCallback(
    (conditions, mainconditions, dashboardConfig) => {
      const alertRules = [];
      let currentTagObjects = [];
      let projectID = "";
      if (userdetails && userdetails.Projectid && userdetails.Organizationid) {
        if (userdetails && userdetails?.Projectid == "All") {
          projectID = projectname;
        } else {
          projectID = userdetails.Projectid;
        }
      }

      // Voltage Harmonics
      const enabledVoltageRows = conditions.filter((row) => row.enable);
      //const enabledVoltageRows = conditions;
      // Current Harmonics
      const enabledCurrentRows = mainconditions.filter((row) => row.enable);
      //const enabledCurrentRows = mainconditions;
      const tddTagObjPF = dashboardConfig.powerFactor.powerFactor;
      console.log(
        "getMergedAlertRules enabledVoltageRows",
        enabledVoltageRows,
        "getMergedAlertRules enabledCurrentRows",
        enabledCurrentRows,
        "tddTagObjPF",
        tddTagObjPF,
        "dashboardConfig",
        dashboardConfig,
      );
      console.log("Merged Alert Rules: 123", enabledVoltageRows);
      enabledVoltageRows.forEach((row) => {
        row.individualharmonics.forEach((harmonic, idx) => {
          ["rPhase", "yPhase", "bPhase"].forEach((phase) => {
            const tagObj =
              dashboardConfig.individualVoltageHarmonics[idx][phase];
            if (tagObj.tagid && harmonic.default_threshold !== undefined) {
              const TagDetails = tagdetailsobject[tagObj.tagid];
              const Alias = TagDetails ? TagDetails.Alias : "";
              const DeviceID = tagdetailsobject[tagObj.tagid]?.DeviceID || "";
              alertRules.push({
                Alert_rule_name: `${Alias}AlertRule`.replace(/\s+/g, ""),
                TagID: tagObj.tagid,
                DeviceID: DeviceID,
                enableAlert: true,
                SendMessage: true,
                SendEmail: true,
                ProjectID: projectID,
                conditions: [
                  {
                    condition: ">=",
                    alarmpriority: "Medium",
                    normalmessage: `${Alias} AlertRule Normal`,
                    abnormalmessage: `${Alias} AlertRule Abnormal`,
                    type: "Conditional",
                    value: {
                      alarm_condition_lower: harmonic.default_threshold,
                      alarm_condition_upper: "INF",
                    },
                  },
                ],
              });
              console.log(
                "getMergedAlertRules tagObj.tagid",
                tagObj.tagid,
                "tagdetailsobject[tagObj.tagid]",
                tagdetailsobject[tagObj.tagid],
              );
              currentTagObjects.push(tagdetailsobject[tagObj.tagid]);
            }
          });
        });

        // Add voltageTotalHarmonicDistortion for enabled voltage row
        ["rPhase", "yPhase", "bPhase"].forEach((phase) => {
          const thdTagObj =
            dashboardConfig.voltageTotalHarmonicDistortion[phase];
          if (
            thdTagObj.tagid &&
            row.thdthreshold !== undefined &&
            row.thdthreshold !== ""
          ) {
            const TagDetails = tagdetailsobject[thdTagObj.tagid];
            const Alias = TagDetails ? TagDetails.Alias : "";
            const DeviceID = tagdetailsobject[thdTagObj.tagid]?.DeviceID || "";
            alertRules.push({
              Alert_rule_name: `${Alias}AlertRule`.replace(/\s+/g, ""),
              TagID: thdTagObj.tagid,
              DeviceID: DeviceID,
              enableAlert: true,
              SendMessage: true,
              SendEmail: true,
              ProjectID: projectID,
              conditions: [
                {
                  condition: ">=",
                  alarmpriority: "Medium",
                  normalmessage: `${Alias} AlertRule Normal`,
                  abnormalmessage: `${Alias} AlertRule Abnormal`,
                  type: "Conditional",
                  value: {
                    alarm_condition_lower: row.thdthreshold,
                    alarm_condition_upper: "INF",
                  },
                },
              ],
            });
            console.log(
              "getMergedAlertRules thdTagObj.tagid",
              thdTagObj.tagid,
              "tagdetailsobject[thdTagObj.tagid]",
              tagdetailsobject[thdTagObj.tagid],
            );
            currentTagObjects.push(tagdetailsobject[thdTagObj.tagid]);
          }
        });
      });

      enabledCurrentRows.forEach((row) => {
        row.individualharmonics.forEach((harmonic, idx) => {
          ["rPhase", "yPhase", "bPhase"].forEach((phase) => {
            const tagObj =
              dashboardConfig.individualCurrentHarmonics[idx][phase];
            if (tagObj.tagid && harmonic.default_threshold !== undefined) {
              const TagDetails = tagdetailsobject[tagObj.tagid];
              const Alias = TagDetails ? TagDetails.Alias : "";
              const DeviceID = tagdetailsobject[tagObj.tagid]?.DeviceID || "";
              alertRules.push({
                Alert_rule_name: `${Alias}AlertRule`.replace(/\s+/g, ""),
                TagID: tagObj.tagid,
                DeviceID: DeviceID,
                enableAlert: true,
                SendMessage: true,
                SendEmail: true,
                ProjectID: projectID,
                conditions: [
                  {
                    condition: ">=",
                    alarmpriority: "Medium",
                    normalmessage: `${Alias} AlertRule Normal`,
                    abnormalmessage: `${Alias} AlertRule Abnormal`,
                    type: "Conditional",
                    value: {
                      alarm_condition_lower: harmonic.default_threshold,
                      alarm_condition_upper: "INF",
                    },
                  },
                ],
              });
              console.log(
                "getMergedAlertRules tagObj.tagid",
                tagObj.tagid,
                "tagdetailsobject[tagObj.tagid]",
                tagdetailsobject[tagObj.tagid],
              );
              currentTagObjects.push(tagdetailsobject[tagObj.tagid]);
            }
          });
        });

        // Add totalDemandDistortion for enabled voltage row
        const tddTagObj = dashboardConfig.totalDemandDistortion.tdd;
        if (
          tddTagObj.tagid &&
          row.tddthreshold !== undefined &&
          row.tddthreshold !== ""
        ) {
          const TagDetails = tagdetailsobject[tddTagObj.tagid];
          const Alias = TagDetails ? TagDetails.Alias : "";
          const DeviceID = tagdetailsobject[tddTagObj.tagid]?.DeviceID || "";
          alertRules.push({
            Alert_rule_name: `${Alias}AlertRule`.replace(/\s+/g, ""),
            TagID: tddTagObj.tagid,
            DeviceID: DeviceID,
            enableAlert: true,
            SendMessage: true,
            SendEmail: true,
            ProjectID: projectID,
            conditions: [
              {
                condition: ">=",
                alarmpriority: "Medium",
                normalmessage: `${Alias} AlertRule Normal`,
                abnormalmessage: `${Alias} AlertRule Abnormal`,
                type: "Conditional",
                value: {
                  alarm_condition_lower: row.tddthreshold,
                  alarm_condition_upper: "INF",
                },
              },
            ],
          });
          console.log(
            "getMergedAlertRules tddTagObj.tagid",
            tddTagObj.tagid,
            "tagdetailsobject[tddTagObj.tagid]",
            tagdetailsobject[tddTagObj.tagid],
          );
          currentTagObjects.push(tagdetailsobject[tddTagObj.tagid]);
        }
      });

      console.log("getMergedAlertRules tddTagObjPF", tddTagObjPF);
      if (tddTagObjPF.tagid) {
        const TagDetails = tagdetailsobject[tddTagObjPF.tagid];
        const Alias = TagDetails ? TagDetails.Alias : "";
        const DeviceID = tagdetailsobject[tddTagObjPF.tagid]?.DeviceID || "";
        alertRules.push({
          Alert_rule_name: `${Alias}AlertRule`.replace(/\s+/g, ""),
          TagID: tddTagObjPF.tagid,
          DeviceID: DeviceID,
          enableAlert: true,
          SendMessage: true,
          SendEmail: true,
          ProjectID: projectID,
          conditions: [
            {
              condition: ">=",
              alarmpriority: "Medium",
              normalmessage: `${Alias} AlertRule Normal`,
              abnormalmessage: `${Alias} AlertRule Abnormal`,
              type: "Conditional",
              value: {
                alarm_condition_lower: 0.8,
                alarm_condition_upper: "INF",
              },
            },
          ],
        });
        console.log(
          "getMergedAlertRules tddTagObjPF.tagid",
          tddTagObjPF.tagid,
          "tagdetailsobject[tddTagObjPF.tagid]",
          tagdetailsobject[tddTagObjPF.tagid],
        );
        currentTagObjects.push(tagdetailsobject[tddTagObjPF.tagid]);
      }
      console.log(
        "PowerQualityConfiguration currentTagObjects",
        currentTagObjects,
      );
      // Remove duplicate TagID entries
      // const uniqueTagObjects = Object.values(
      // currentTagObjects.reduce((acc, obj) => {
      //     acc[obj.TagID] = obj; // Only the last occurrence is kept
      //     return acc;
      // }, {})
      // );
      setTagObjects(currentTagObjects);
      return alertRules;
    },
    [userdetails, projectname, tagdetailsobject, dashboardConfig],
  );

  // Optimized input handlers with useCallback
  const handleInputHarmonicsNumber = useCallback((index, field, value) => {
    console.log("handleInputHarmonicsNumber field", field, "value", value);
    if (field == "No of Voltage Harmonics") {
      setDashboardConfig((prev) => {
        const updatedConfig = { ...prev };
        updatedConfig.noOfHarmonics.noOfVoltageHarmonics.value = value;
        return updatedConfig;
      });
    } else if (field == "No of Current Harmonics") {
      setDashboardConfig((prev) => {
        const updatedConfig = { ...prev };
        updatedConfig.noOfHarmonics.noOfCurrentHarmonics.value = value;
        return updatedConfig;
      });
    } else if (field == "Dashboard Name") {
      setDashboardConfig((prev) => {
        const updatedConfig = { ...prev };
        updatedConfig.noOfHarmonics.dashboardName.value = value;
        return updatedConfig;
      });
    }
  }, []);

  function handleCloseDeleteCurrentHarmonicSuccess() {
    setCurrentHarmonicsSuccess(false);
  }

  function handleCloseDeleteCurrentHarmonicFailed() {
    setCurrentHarmonicsFailed(false);
  }

  function handleCloseDeleteVoltageHarmonicSuccess() {
    setVoltageHarmonicsSuccess(false);
  }

  function handleCloseDeleteVoltageHarmonicFailed() {
    setVoltageHarmonicsFailed(false);
  }

  // Checkbox handler for reports
  const handleReportTagCheckboxChange = useCallback(
    (idx) => {
      setSelectedReportTagObjects((prev) => {
        const tag = tagObjects[idx];
        if (prev.some((t) => t.TagID === tag.TagID)) {
          // Remove tag
          return prev.filter((t) => t.TagID !== tag.TagID);
        } else {
          // Add tag
          return [...prev, tag];
        }
      });
    },
    [tagObjects],
  );

  const restcallbackdashboard = useCallback((res) => {
    var dashboardli = [],
      dashboardProLi = [],
      groupidLi = [];
    for (let i = 0; i < res.dashboardlist.length; i++) {
      dashboardli.push(res.dashboardlist[i].Dashboardname);
      dashboardProLi.push(res.dashboardlist[i].dashboard_pro);
      groupidLi.push(res.dashboardlist[i].groupid);
    }
    setDashboardList(dashboardli);
    setDashboardPro(dashboardProLi);
    setGroupid(groupidLi);
  }, []);

  const handleInputChange = useCallback((field, value) => {
    console.log("handleInputChange field", field, "value", value);
    setThresholds((prev) => {
      const updatedConfig = { ...prev };
      updatedConfig[field].value = value;
      return updatedConfig;
    });
  }, []);

  const assetcallback = useCallback((res) => {
    console.log("res obtd in assetscallback in OverviewHomePage", res);
    if (res.success == true) {
      setAssetData({ devices: res.devices });
    } else {
      setAssetData({ devices: {} });
    }
  }, []);

  // Optimized useEffect for selectedTag with proper dependency handling
  useEffect(() => {
    console.log("focusedFieldKey", focusedFieldKey, "selectedTag", selectedTag);
    // Only allow assignment if a tag is selected (not by clicking placeholder first)
    if (focusedFieldKey && selectedTag?.tagname) {
      // Prevent duplicate tag assignment
      let isDuplicate = false;
      // Recursively check all placeholders for the same tagid
      function checkDuplicate(obj) {
        if (obj && typeof obj === "object") {
          for (const key in obj) {
            if (obj[key] && typeof obj[key] === "object") {
              if (obj[key].tagid && obj[key].tagid === selectedTag.tagid) {
                return true;
              }
              if (checkDuplicate(obj[key])) return true;
            }
          }
        }
        return false;
      }
      // Remove the current focusedFieldKey from the check
      const keys = focusedFieldKey.replace(/\[(\d+)\]/g, ".$1").split(".");
      let obj = dashboardConfig;
      for (let i = 0; i < keys.length - 1; i++) {
        const key = isFinite(keys[i]) ? Number(keys[i]) : keys[i];
        obj = obj[key];
      }
      const finalKey = keys[keys.length - 1];
      // Temporarily clear the tagid at the target placeholder for duplicate check
      const originalTagid = obj[finalKey].tagid;
      obj[finalKey].tagid = "";
      isDuplicate = checkDuplicate(dashboardConfig);
      obj[finalKey].tagid = originalTagid;
      if (isDuplicate) {
        if (!duplicateDialogBlockRef.current) {
          setDuplicateTagDialogMsg(
            `This tag is already assigned to another placeholder. Duplicate assignments are not allowed.`,
          );
          setDuplicateTagDialogOpen(true);
          duplicateDialogBlockRef.current = true;
        }
        setFocusedFieldKey(null);
        setSelectedTag(null);
        return;
      }
      setDashboardConfig((prev) => {
        const updatedConfig = { ...prev };
        const keys = focusedFieldKey.replace(/\[(\d+)\]/g, ".$1").split(".");
        let obj = updatedConfig;
        for (let i = 0; i < keys.length - 1; i++) {
          const key = isFinite(keys[i]) ? Number(keys[i]) : keys[i];
          obj = obj[key];
        }
        const finalKey = keys[keys.length - 1];
        obj[finalKey].value = selectedTag.tagname;
        obj[finalKey].tagid = selectedTag.tagid;
        return updatedConfig;
      });
      setFocusedFieldKey(null);
      setSelectedTag(null);
      duplicateDialogBlockRef.current = false;
    }
    // If user tries to assign by clicking placeholder first (no tag selected), block assignment
    if (focusedFieldKey && (!selectedTag || !selectedTag.tagname)) {
      setFocusedFieldKey(null);
      return;
    }
  }, [selectedTag, focusedFieldKey, dashboardConfig]);
  // Duplicate tag warning dialog
  const handleCloseDuplicateTagDialog = () => {
    setDuplicateTagDialogOpen(false);
    duplicateDialogBlockRef.current = false;
  };

  const handleOpenDialog = useCallback((index) => {
    setOpenDialogIndex(index);
  }, []);

  const handleOpenAlertsConfig = useCallback(() => {
    setDialogContentLoading(true);
    // Use setTimeout to allow UI to show loading state
    setTimeout(() => {
      setConfigAlerts(true);
      setConfigReports(false);

      const mergedAlertRules = getMergedAlertRules(
        conditions,
        mainconditions,
        dashboardConfig,
      );
      setAlertRules(mergedAlertRules);
      setSelectedAlertIndexes([]);
      setDialogContentLoading(false);
      console.log("Merged Alert Rules:", mergedAlertRules);
    }, 50);
  }, [conditions, mainconditions, dashboardConfig]);

  // Checkbox handler with useCallback
  const handleAlertCheckboxChange = useCallback((idx) => {
    setSelectedAlertIndexes((prev) => {
      if (prev.includes(idx)) {
        return prev.filter((i) => i !== idx);
      } else {
        return [...prev, idx];
      }
    });
  }, []);

  // Save only selected alerts
  // const handleSaveSelectedAlerts = useCallback(() => {
  //     const selectedAlerts = selectedAlertIndexes.map(idx => alertRules[idx]);
  //     console.log("handleSaveSelectedAlerts selectedAlerts", selectedAlerts);
  //     // Call your save API here
  // }, [selectedAlertIndexes, alertRules]);
  // Enhanced handleSaveSelectedAlerts function - NO BACKEND CHANGES
  const handleSaveSelectedAlerts = useCallback(async () => {
    const selectedAlerts = selectedAlertIndexes.map((idx) => alertRules[idx]);

    if (selectedAlerts.length === 0) {
      alert("No alerts selected");
      return;
    }

    // Initialize progress state
    setIsSaving(true);
    setSaveProgress({
      total: selectedAlerts.length,
      current: 0,
      completed: 0,
      failed: 0,
      currentAlertName: "",
      results: [],
    });

    try {
      await saveAlertsOneByOne(selectedAlerts);
    } catch (error) {
      console.error("Error in batch save:", error);
    } finally {
      // Keep modal open for 2 seconds to show final results
      setTimeout(() => {
        setIsSaving(false);
        setSaveProgress({
          total: 0,
          current: 0,
          completed: 0,
          failed: 0,
          currentAlertName: "",
          results: [],
        });
      }, 2000);
    }
  }, [selectedAlertIndexes, alertRules]);

  // Save alerts one by one using existing API
  const saveAlertsOneByOne = async (alertsToSave) => {
    const results = [];

    for (let i = 0; i < alertsToSave.length; i++) {
      const alert = alertsToSave[i];
      const alertName = alert.Alert_rule_name || `Alert ${i + 1}`;

      // Update current progress
      setSaveProgress((prev) => ({
        ...prev,
        current: i + 1,
        currentAlertName: alertName,
      }));

      try {
        // Use existing postalarmconfig function with Promise wrapper
        const result = await saveAlertPromise(alert);

        // Success
        const successResult = {
          alertName: alertName,
          status: "success",
          message: "Saved successfully",
          timestamp: new Date().toLocaleTimeString(),
        };

        results.push(successResult);

        // Update progress with success
        setSaveProgress((prev) => ({
          ...prev,
          completed: prev.completed + 1,
          results: [...prev.results, successResult],
        }));

        console.log(`✅ Successfully saved: ${alertName}`);
      } catch (error) {
        // Failure
        const failedResult = {
          alertName: alertName,
          status: "failed",
          message: error.message || "Already Created Saved",
          timestamp: new Date().toLocaleTimeString(),
        };

        results.push(failedResult);

        // Update progress with failure
        setSaveProgress((prev) => ({
          ...prev,
          failed: prev.failed + 1,
          results: [...prev.results, failedResult],
        }));

        console.error(` Already Created: ${alertName}`, error);
      }

      // Small delay between requests (optional - prevents server overload)
      if (i < alertsToSave.length - 1) {
        await new Promise((resolve) => setTimeout(resolve, 200));
      }
    }

    // Log final summary
    const successCount = results.filter((r) => r.status === "success").length;
    const failedCount = results.filter((r) => r.status === "failed").length;

    console.log(
      ` Batch Save Complete - Success: ${successCount}, Already Created: ${failedCount}`,
    );

    return results;
  };

  // Promise wrapper for existing postalarmconfig function
  const saveAlertPromise = (alertConfig) => {
    return new Promise((resolve, reject) => {
      postalarmconfig(
        alertConfig,
        userdetails.Userid, // Make sure these are available in your component scope
        projectname,
        (response, status) => {
          console.log(
            `API Response for ${alertConfig.Alert_rule_name}:`,
            response,
            status,
          );

          // Handle different response formats
          if (status === "error") {
            reject(new Error(response || "Unknown error occurred"));
          } else if (
            response &&
            response.data &&
            response.data.success === false
          ) {
            reject(new Error(response.data.message || "API returned failure"));
          } else if (response && response.status && response.status >= 400) {
            reject(new Error(response.statusText || `HTTP ${response.status}`));
          } else {
            // Consider it successful
            resolve(response);
          }
        },
      );
    });
  };

  const handleOpenReportsConfig = useCallback(() => {
    setDialogContentLoading(true);

    setTimeout(() => {
      setConfigReports(true);
      setConfigAlerts(false);
      const mergedAlertRules = getMergedReportRules(
        conditions,
        mainconditions,
        dashboardConfig,
      );
      setDialogContentLoading(false);
    }, 50);
  }, [conditions, mainconditions, dashboardConfig]);

  const restaddcallback = useCallback((res) => {
    console.log("restaddcallback res", res);
    if (res.data === 1) {
      setGroupCreated("Energy Management Group Created Successfully");
    } else if (res.data === 2) {
      setGroupCreated("Energy Management Group Already Exists");
    } else {
      setGroupCreated("Energy Management Group Creation Failed");
    }
  }, []);

  const handleAddReportGroup = useCallback(() => {
    addTemplateGroup("Energy Management", restaddcallback);
  }, [userdetails.Userid, username, restaddcallback]);

  const templatecallback = useCallback((res) => {
    console.log("restaddcallback res", res);
    if (res.data === 1) {
      setTemplateCreated("Energy Management Template Created Successfully");
    } else if (res.data === 2) {
      setTemplateCreated(
        "Energy Management Template Already Exists.Go to Templates to Edit",
      );
    } else {
      setTemplateCreated("Energy Management Template Creation Failed");
    }
  }, []);

  // Complete SaveProgressModal component to add to your file
  const SaveProgressModal = () => {
    if (!isSaving) return null;
    const progressPercentage =
      saveProgress.total > 0
        ? Math.round((saveProgress.current / saveProgress.total) * 100)
        : 0;

    const isComplete = saveProgress.current === saveProgress.total;

    return (
      <>
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: themechange === "light" ? "#FFFFFF" : "#595963ff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              backgroundColor: themechange === "light" ? "#FFFFFF" : "#19191B",
              padding: "24px",
              borderRadius: "8px",
              boxShadow:
                "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
              maxWidth: "500px",
              width: "90%",
              maxHeight: "80vh",
              overflow: "hidden",
            }}
          >
            {/* Header */}
            <div
              style={{
                textAlign: "center",
                marginBottom: "24px",
                backgroundColor:
                  themechange === "light" ? "#FFFFFF" : "#19191B",
              }}
            >
              <h3
                style={{
                  fontSize: "20px",
                  fontWeight: "600",
                  color: themechange === "light" ? "#1f2937" : "#FFFFFF",
                  margin: "0 0 4px 0",
                }}
              >
                {isComplete ? "Save Complete!" : "Saving Alert Rules"}
              </h3>
              <p
                style={{
                  color: themechange === "light" ? "#1f2937" : "#FFFFFF",
                  margin: 0,
                  fontSize: "14px",
                }}
              >
                {saveProgress.current} of {saveProgress.total} processed
              </p>
            </div>

            {/* Circular Progress */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "24px",
              }}
            >
              <div
                style={{ position: "relative", width: "64px", height: "64px" }}
              >
                <svg
                  style={{
                    width: "64px",
                    height: "64px",
                    transform: "rotate(-90deg)",
                  }}
                  viewBox="0 0 100 100"
                >
                  {/* Background circle */}
                  <circle
                    cx="50"
                    cy="50"
                    r="45"
                    fill="none"
                    stroke="#e5e7eb"
                    strokeWidth="6"
                  />
                  {/* Progress circle */}
                  <circle
                    cx="50"
                    cy="50"
                    r="45"
                    fill="none"
                    stroke={isComplete ? "#10b981" : "#3b82f6"}
                    strokeWidth="6"
                    strokeDasharray={`${progressPercentage * 2.827} 282.7`}
                    style={{
                      transition: "all 0.5s ease-out",
                      strokeLinecap: "round",
                    }}
                  />
                </svg>
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div style={{ textAlign: "center" }}>
                    <div
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                        color: "#1f2937",
                      }}
                    >
                      {progressPercentage}%
                    </div>
                    <div
                      style={{
                        fontSize: "10px",
                        color: "#6b7280",
                      }}
                    >
                      {isComplete ? "Done" : "Saving"}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Current Alert Being Processed */}
            {!isComplete && saveProgress.currentAlertName && (
              <div
                style={{
                  textAlign: "center",
                  marginBottom: "16px",
                  padding: "12px",
                  backgroundColor: "#eff6ff",
                  borderRadius: "8px",
                }}
              >
                <p
                  style={{
                    fontSize: "14px",
                    color: "#6b7280",
                    margin: "0 0 4px 0",
                  }}
                >
                  Currently saving:
                </p>
                <p
                  style={{
                    fontWeight: "500",
                    color: "#1f2937",
                    margin: 0,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {saveProgress.currentAlertName}
                </p>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "8px",
                  }}
                >
                  <div
                    style={{
                      width: "16px",
                      height: "16px",
                      border: "2px solid #3b82f6",
                      borderTop: "2px solid transparent",
                      borderRadius: "50%",
                      animation: "spin 1s linear infinite",
                    }}
                  ></div>
                </div>
              </div>
            )}

            {/* Status Summary */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr",
                gap: "16px",
                marginBottom: "16px",
                textAlign: "center",
              }}
            >
              <div
                style={{
                  backgroundColor: "#f0fdf4",
                  padding: "12px",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    fontSize: "24px",
                    fontWeight: "bold",
                    color: "#16a34a",
                  }}
                >
                  {saveProgress.completed}
                </div>
                <div
                  style={{
                    fontSize: "12px",
                    color: "#15803d",
                  }}
                >
                  Success
                </div>
              </div>
              <div
                style={{
                  backgroundColor: "#fef2f2",
                  padding: "12px",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    fontSize: "24px",
                    fontWeight: "bold",
                    color: "#dc2626",
                  }}
                >
                  {saveProgress.failed}
                </div>
                <div
                  style={{
                    fontSize: "12px",
                    color: "#dc2626",
                  }}
                >
                  Already Created
                </div>
              </div>
              <div
                style={{
                  backgroundColor: "#f9fafb",
                  padding: "12px",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    fontSize: "24px",
                    fontWeight: "bold",
                    color: "#6b7280",
                  }}
                >
                  {saveProgress.total - saveProgress.current}
                </div>
                <div
                  style={{
                    fontSize: "12px",
                    color: "#6b7280",
                  }}
                >
                  Remaining
                </div>
              </div>
            </div>

            {/* Recent Results */}
            <div style={{ borderTop: "1px solid #e5e7eb", paddingTop: "16px" }}>
              <h4
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#374151",
                  margin: "0 0 8px 0",
                }}
              >
                Recent Results:
              </h4>
              <div
                style={{
                  maxHeight: "128px",
                  overflowY: "auto",
                }}
              >
                {saveProgress.results
                  .slice(-5)
                  .reverse()
                  .map((result, index) => (
                    <div
                      key={`${result.alertName}-${result.timestamp}`}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "8px",
                        marginBottom: "8px",
                        borderRadius: "4px",
                        fontSize: "14px",
                        backgroundColor:
                          result.status === "success" ? "#f0fdf4" : "#fef2f2",
                        borderLeft: `4px solid ${result.status === "success" ? "#22c55e" : "#ef4444"}`,
                      }}
                    >
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <p
                          style={{
                            fontWeight: "500",
                            margin: "0 0 2px 0",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {result.alertName}
                        </p>
                        <p
                          style={{
                            fontSize: "12px",
                            color: "#6b7280",
                            margin: 0,
                          }}
                        >
                          {result.timestamp}
                        </p>
                      </div>
                      <div
                        style={{
                          marginLeft: "8px",
                          color:
                            result.status === "success" ? "#16a34a" : "#dc2626",
                        }}
                      >
                        {result.status === "success" ? "✅" : "❌"}
                      </div>
                    </div>
                  ))}
                {saveProgress.results.length === 0 && (
                  <p
                    style={{
                      color: "#6b7280",
                      fontSize: "14px",
                      textAlign: "center",
                      padding: "8px",
                      margin: 0,
                    }}
                  >
                    No results yet...
                  </p>
                )}
              </div>
            </div>

            {/* Final Summary (shown when complete) */}
            {isComplete && (
              <div
                style={{
                  marginTop: "16px",
                  padding: "16px",
                  backgroundColor: "#f9fafb",
                  borderRadius: "8px",
                  textAlign: "center",
                }}
              >
                <p
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    color: themechange === "light" ? "#3C3C3C" : "#FFFFFF",
                    margin: "0 0 4px 0",
                  }}
                >
                  Batch save completed!
                </p>
                <p
                  style={{
                    fontSize: "12px",
                    color: themechange === "light" ? "#6b7280" : "#FFFFFF",
                    margin: "0 0 8px 0",
                  }}
                >
                  {saveProgress.completed} successful, {saveProgress.failed}{" "}
                  failed
                </p>
                <p
                  style={{
                    fontSize: "12px",
                    color: "#9ca3af",
                    margin: 0,
                  }}
                >
                  This dialog will close automatically...
                </p>
              </div>
            )}
          </div>

          {/* Add CSS for spinner animation */}
          <style jsx>{`
            @keyframes spin {
              from {
                transform: rotate(0deg);
              }
              to {
                transform: rotate(360deg);
              }
            }
          `}</style>
        </div>
      </>
    );
  };

  const handleAddReportTemplate = useCallback(() => {
    let tagStrings = [];
    const aggregateObjects = selectedReportTagObjects.map((tag) => {
      const aggregates =
        tag.StorageID.length > 0
          ? [...new Set(tag.StorageID.map((func) => func.Function))]
          : [];

      const uniqueAggregates = [...new Set(aggregates)];
      const tagID = tag.TagID;
      const deviceID = tagdetailsobject[tagID]?.DeviceID;
      const deviceName = devicedetailsobject[deviceID]?.Name || "";
      const tagName = tagdetailsobject[tagID]?.Name || "";
      const tagAlias = tagdetailsobject[tagID]?.Alias || "";
      let aggregate = "";
      for (let i = 0; i < uniqueAggregates.length; i++) {
        if (uniqueAggregates[i] === "SVAL") {
          aggregate = "Start Value";
        } else if (uniqueAggregates[i] === "EVAL") {
          aggregate = "End Value";
        } else if (uniqueAggregates[i] === "DIFF") {
          aggregate = "Difference";
        } else if (uniqueAggregates[i] === "AVG") {
          aggregate = "Average";
        } else if (uniqueAggregates[i] === "MAX") {
          aggregate = "Maximum";
        } else if (uniqueAggregates[i] === "MIN") {
          aggregate = "Minimum";
        } else if (uniqueAggregates[i] === "SUM") {
          aggregate = "Summation";
        }
      }
      const finalString = `${tagID}~${deviceName}~${tagName}~${deviceName}~${tagAlias}~${aggregate}`;
      tagStrings.push(finalString);

      return {
        aggregate: uniqueAggregates,
        tagID: tag.TagID,
      };
    });
    if (
      Array.isArray(aggregateObjects) &&
      aggregateObjects.length > 0 &&
      Array.isArray(tagStrings) &&
      tagStrings.length > 0
    ) {
      const tempObj = {
        OrganizationID: logindetails.Organizationid,
        ProjectID: projectId,
        name:
          "Energy Management Power Quality Report " +
          dashboardConfig.noOfHarmonics.dashboardName.value,
        userID: username,
        groupID: "Energy Management",
        groupName: "Energy Management",
        template_type: "Archive",
        report_type: "General",
        dynamic: false,
        report_title:
          "Energy Management Power Quality Report " +
          dashboardConfig.noOfHarmonics.dashboardName.value,
        report_description:
          "Energy Management Power Quality Report " +
          dashboardConfig.noOfHarmonics.dashboardName.value,
        tags: aggregateObjects,
        duration: "1 hour",
        decimal_digit: "2",
        orientation: "Portrait",
        interval: "Hourly",
        selectedTagType: tagStrings,
      };

      console.log("tempObj", tempObj);
      addTemplate(tempObj, templatecallback);
    }
  }, [
    selectedReportTagObjects,
    tagdetailsobject,
    devicedetailsobject,
    logindetails,
    projectId,
    username,
    templatecallback,
  ]);

  const restlinkcallback = useCallback((res) => {
    console.log("restlinkcallback", res);
    console.log("restaddcallback res", res);
    if (res.data === 1) {
      setDashboardLinked("Dashboard Linked Successfully");
    } else if (res.data === 2) {
      setDashboardLinked("Dashboard Link Already Exists.");
    } else {
      setDashboardLinked("Dashboard Link Creation Failed");
    }
  }, []);

  const handleDashboardReportGroup = useCallback(() => {
    console.log(
      "dashboardConfig.noOfHarmonics.dashboardName.value",
      dashboardConfig.noOfHarmonics.dashboardName.value,
    );
    linkDashboardtoTemplate(
      "Energy Management Power Quality Report " +
        dashboardConfig.noOfHarmonics.dashboardName.value,
      dashboardConfig.noOfHarmonics.dashboardName.value,
      dashboardPro[
        dashboardList.indexOf(dashboardConfig.noOfHarmonics.dashboardName.value)
      ],
      groupid[
        dashboardList.indexOf(dashboardConfig.noOfHarmonics.dashboardName.value)
      ],
      username,
      restlinkcallback,
    );
  }, [
    dashboardConfig,
    dashboardPro,
    dashboardList,
    groupid,
    username,
    restlinkcallback,
  ]);

  const handleCloseDialog = useCallback(() => {
    setOpenDialogIndex(null);
  }, []);

  const handleOpenCurrentHarmonicDialog = useCallback((index) => {
    setOpenDialogCurrentHarmonicIndex(index);
  }, []);

  const handleCloseGoToDashboard = useCallback(() => {
    setConfigAlerts(false);
    setConfigReports(false);
  }, []);

  const handleCloseCurrentHarmonicDialog = useCallback(() => {
    setOpenDialogCurrentHarmonicIndex(null);
  }, []);

  // Optimized dialog open handler with async loading
  const handleConfigureDashboard = useCallback(() => {
    setOpenDashboardDialog(true);
    setDialogContentLoading(true);

    // Simulate async loading to prevent blocking
    setTimeout(() => {
      setDialogContentLoading(false);
    }, 100);
  }, []);

  const handleCloseCreateDashboard = useCallback(() => {
    setCreatedSuccess(false);
  }, []);

  const handleCloseNotCreateDashboard = useCallback(() => {
    setNotCreatedSuccess(false);
  }, []);

  const postPQDashboardCallback = useCallback((res) => {
    console.log("postPQDashboardCallback", res);
    if (res.data.success == true) {
      setCreatedSuccess(true);
      getdashboarlist(
        logindetails.Organizationid,
        projectId,
        "All",
        restcallbackdashboard,
      );
    } else {
      setNotCreatedMessage(
        res.data.message || "Failed to create Power Quality Dashboard",
      );
      setNotCreatedSuccess(true);
    }
  }, []);

  const handleSaveConfiguredDashboard = useCallback(() => {
    if (userdetails && userdetails.Projectid && userdetails.Organizationid) {
      console.log(
        "At Dashboard dashboardConfig",
        dashboardConfig,
        "userdetails",
        userdetails,
        "isValidLengthNew(dashboardConfig.noOfHarmonics.dashboardName,5,30)",
        isValidLengthNew(dashboardConfig.noOfHarmonics.dashboardName, 5, 30),
        "containsSpacesOrSpecialChars(dashboardConfig.noOfHarmonics.dashboardName))",
        containsSpacesOrSpecialChars(
          dashboardConfig.noOfHarmonics.dashboardName,
        ),
        "dashboardConfig.noOfHarmonics.dashboardName",
        dashboardConfig.noOfHarmonics.dashboardName,
      );

      if (
        !isValidLengthNew(
          dashboardConfig.noOfHarmonics.dashboardName.value,
          5,
          30,
        ) ||
        containsSpacesOrSpecialChars(
          dashboardConfig.noOfHarmonics.dashboardName.value,
        )
      ) {
        setopenAlertRuleNameExceedsLength(true);
        return;
      }

      if (userdetails && userdetails?.Projectid == "All") {
        postPQDashboard(
          dashboardConfig,
          projectname,
          userdetails.Organizationid,
          postPQDashboardCallback,
        );
      } else {
        postPQDashboard(
          dashboardConfig,
          userdetails.Projectid,
          userdetails.Organizationid,
          postPQDashboardCallback,
        );
      }
      // Call getdashboarlist after saving dashboard
      getdashboarlist(
        logindetails.Organizationid,
        projectId,
        "All",
        restcallbackdashboard,
      );
    } else {
      console.error("User details are not available or invalid.");
    }
    setConfigAlerts(false);
    setConfigReports(false);
  }, [
    dashboardConfig,
    userdetails,
    projectname,
    postPQDashboardCallback,
    logindetails.Organizationid,
    projectId,
    restcallbackdashboard,
  ]);

  const handleCloseConfigureDashboard = useCallback(() => {
    setOpenDashboardDialog(false);
    setConfigAlerts(false);
    setConfigReports(false);
  }, []);

  const handlefetchData = useCallback(() => {
    setfetchdataConfirm(true);
  }, []);

  const handlefetchDataConfirm = useCallback(() => {
    if (userdetails?.Projectid == "All") {
      fetchPowerQualityData(fetchPowerQualityDatacallback, projectname);
    } else {
      fetchPowerQualityData(
        fetchPowerQualityDatacallback,
        userdetails?.Projectid,
      );
    }
    setfetchdataConfirm(false);
  }, [userdetails, projectname]);

  const handleClosefetchDataConfirm = useCallback(() => {
    setfetchdataConfirm(false);
  }, []);

  const handleCloseNotFetchedPQData = useCallback(() => {
    setNotFetchedPQData(false);
  }, []);

  const handleCloseNotGetPQData = useCallback(() => {
    setNotGetPQData(false);
  }, []);

  const fetchPowerQualityDatacallback = useCallback((res) => {
    if (res?.data?.status == "success") {
      if (
        res != undefined &&
        res?.data?.voltageharmonicsdetails != undefined &&
        res?.data?.currentharmonicdetails != undefined
      ) {
        setConditions(res.data.voltageharmonicsdetails);
        setMainConditions(res.data.currentharmonicdetails);
        setEnablefetchData(false);
      } else {
        setNotFetchedPQData(true);
        setConditions([]);
        setMainConditions([]);
      }
    } else {
      setNotFetchedPQData(true);
      setConditions([]);
      setMainConditions([]);
    }
  }, []);

  const handleClosedeletevoltageConfirmation = useCallback(() => {
    setDeleteVoltageConfirmation(false);
  }, []);

  const handleClosedeletecurrentConfirmation = useCallback(() => {
    setDeletecurrentConfirmation(false);
  }, []);

  const [PQDetails, setPQDetails] = useState({
    hvdcterminal: false,
    sccurrent: "",
    maxloadcurrent: "",
  });

  const handlePQDetailsChange = useCallback(
    (field, value) => {
      if (field == "hvdcterminal") {
        setPQDetails({ ...PQDetails, [field]: !PQDetails.hvdcterminal });
      } else {
        setPQDetails({ ...PQDetails, [field]: value });
      }
    },
    [PQDetails],
  );

  const handleCloseinvalidLimits = useCallback(() => {
    setInValidLimits(false);
  }, []);

  const handleCloseinvalidLimitsLowerUpper = useCallback(() => {
    setInValidLimitsLowerUpper(false);
  }, []);

  const handleConditionChange = useCallback(
    (index, currentindividualharmonic, field, value) => {
      if (
        field == "pcclowerlimit" ||
        field == "pccupperlimit" ||
        field == "thdthreshold" ||
        field == "individualharmonics:default_threshold"
      ) {
        if (value != "") {
          if (Number(value) < 0 || Number(value) > 100000) {
            setInValidLimits(true);
            return;
          }
        }
      }

      var updatedConditions;
      if (field == "individualharmonics:default_threshold") {
        var previousconditions = [...conditions];
        previousconditions[index].individualharmonics[
          currentindividualharmonic
        ].default_threshold = Number(value);
        updatedConditions = previousconditions;
      } else if (field == "individualharmonics:Alias") {
        var previousconditions = [...conditions];
        previousconditions[index].individualharmonics[
          currentindividualharmonic
        ].Alias = value;
        updatedConditions = previousconditions;
      } else if (field == "enable") {
        updatedConditions = conditions.map((condition, i) =>
          i === index
            ? { ...condition, [field]: true }
            : { ...condition, [field]: false },
        );
      } else {
        updatedConditions = conditions.map((condition, i) =>
          i === index ? { ...condition, [field]: value } : condition,
        );
      }

      setConditions(updatedConditions);
    },
    [conditions],
  );

  const handleMainConditionChange = useCallback(
    (index, currentindividualharmonic, field, value) => {
      console.log(
        "handleMainConditionChange-index",
        index,
        "currentindividualharmonic",
        currentindividualharmonic,
        "field",
        field,
        "value",
        value,
        "mainconditions",
        mainconditions,
      );

      if (
        field == "pcclowerlimit" ||
        field == "pccupperlimit" ||
        field == "tddthreshold" ||
        field == "individualharmonics:default_threshold" ||
        field == "isc_il_ratio_upper_limit" ||
        field == "isc_il_ratio_lower_limit"
      ) {
        if (value != "") {
          if (Number(value) < 0 || Number(value) > 100000) {
            setInValidLimits(true);
            return;
          }
        }
      }

      var updatedConditions;
      if (field == "individualharmonics:default_threshold") {
        var previousconditions = [...mainconditions];
        previousconditions[index].individualharmonics[
          currentindividualharmonic
        ].default_threshold = Number(value);
        updatedConditions = previousconditions;
      } else if (field == "individualharmonics:Alias") {
        var previousconditions = [...mainconditions];
        previousconditions[index].individualharmonics[
          currentindividualharmonic
        ].Alias = value;
        updatedConditions = previousconditions;
      } else if (field == "enable") {
        updatedConditions = mainconditions.map((condition, i) =>
          i === index
            ? { ...condition, [field]: true }
            : { ...condition, [field]: false },
        );
      } else {
        updatedConditions = mainconditions.map((condition, i) =>
          i === index ? { ...condition, [field]: value } : condition,
        );
      }

      console.log(
        "handleMainConditionChange updatedConditions",
        updatedConditions,
      );
      setMainConditions(updatedConditions);
    },
    [mainconditions],
  );

  // Generate UUID function
  const generateCustomUUID = useCallback(() => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        const r = (Math.random() * 16) | 0,
          v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      },
    );
  }, []);

  // Memoize the default harmonics array to prevent recreation
  const defaultHarmonics = useMemo(
    () => [
      {
        harmonic_order: 1,
        default_threshold: 0,
        Alias: "1st Harmonics Threshold",
      },
      {
        harmonic_order: 2,
        default_threshold: 0,
        Alias: "2nd Harmonics Threshold",
      },
      {
        harmonic_order: 3,
        default_threshold: 0,
        Alias: "3rd Harmonics Threshold",
      },
      {
        harmonic_order: 4,
        default_threshold: 0,
        Alias: "4th Harmonics Threshold",
      },
      {
        harmonic_order: 5,
        default_threshold: 0,
        Alias: "5th Harmonics Threshold",
      },
      {
        harmonic_order: 6,
        default_threshold: 0,
        Alias: "6th Harmonics Threshold",
      },
      {
        harmonic_order: 7,
        default_threshold: 0,
        Alias: "7th Harmonics Threshold",
      },
      {
        harmonic_order: 8,
        default_threshold: 0,
        Alias: "8th Harmonics Threshold",
      },
      {
        harmonic_order: 9,
        default_threshold: 0,
        Alias: "9th Harmonics Threshold",
      },
      {
        harmonic_order: 10,
        default_threshold: 0,
        Alias: "10th Harmonics Threshold",
      },
      {
        harmonic_order: 11,
        default_threshold: 0,
        Alias: "11th Harmonics Threshold",
      },
      {
        harmonic_order: 12,
        default_threshold: 0,
        Alias: "12th Harmonics Threshold",
      },
      {
        harmonic_order: 13,
        default_threshold: 0,
        Alias: "13th Harmonics Threshold",
      },
      {
        harmonic_order: 14,
        default_threshold: 0,
        Alias: "14th Harmonics Threshold",
      },
      {
        harmonic_order: 15,
        default_threshold: 0,
        Alias: "15th Harmonics Threshold",
      },
      {
        harmonic_order: 16,
        default_threshold: 0,
        Alias: "16th Harmonics Threshold",
      },
      {
        harmonic_order: 17,
        default_threshold: 0,
        Alias: "17th Harmonics Threshold",
      },
      {
        harmonic_order: 18,
        default_threshold: 0,
        Alias: "18th Harmonics Threshold",
      },
      {
        harmonic_order: 19,
        default_threshold: 0,
        Alias: "19th Harmonics Threshold",
      },
      {
        harmonic_order: 20,
        default_threshold: 0,
        Alias: "320th Harmonics Threshold",
      },
      {
        harmonic_order: 21,
        default_threshold: 0,
        Alias: "21st Harmonics Threshold",
      },
      {
        harmonic_order: 22,
        default_threshold: 0,
        Alias: "22nd Harmonics Threshold",
      },
      {
        harmonic_order: 23,
        default_threshold: 0,
        Alias: "23rd Harmonics Threshold",
      },
      {
        harmonic_order: 24,
        default_threshold: 0,
        Alias: "24th Harmonics Threshold",
      },
      {
        harmonic_order: 25,
        default_threshold: 0,
        Alias: "25th Harmonics Threshold",
      },
      {
        harmonic_order: 26,
        default_threshold: 0,
        Alias: "26th Harmonics Threshold",
      },
      {
        harmonic_order: 27,
        default_threshold: 0,
        Alias: "27th Harmonics Threshold",
      },
      {
        harmonic_order: 28,
        default_threshold: 0,
        Alias: "28th Harmonics Threshold",
      },
      {
        harmonic_order: 29,
        default_threshold: 0,
        Alias: "29th Harmonics Threshold",
      },
      {
        harmonic_order: 30,
        default_threshold: 0,
        Alias: "30th Harmonics Threshold",
      },
      {
        harmonic_order: 31,
        default_threshold: 0,
        Alias: "31st Harmonics Threshold",
      },
      {
        harmonic_order: 32,
        default_threshold: 0,
        Alias: "32th Harmonics Threshold",
      },
      {
        harmonic_order: 33,
        default_threshold: 0,
        Alias: "33rd Harmonics Threshold",
      },
      {
        harmonic_order: 34,
        default_threshold: 0,
        Alias: "34th Harmonics Threshold",
      },
      {
        harmonic_order: 35,
        default_threshold: 0,
        Alias: "35th Harmonics Threshold",
      },
      {
        harmonic_order: 36,
        default_threshold: 0,
        Alias: "36th Harmonics Threshold",
      },
      {
        harmonic_order: 37,
        default_threshold: 0,
        Alias: "37th Harmonics Threshold",
      },
      {
        harmonic_order: 38,
        default_threshold: 0,
        Alias: "38th Harmonics Threshold",
      },
      {
        harmonic_order: 39,
        default_threshold: 0,
        Alias: "39th Harmonics Threshold",
      },
      {
        harmonic_order: 40,
        default_threshold: 0,
        Alias: "40th Harmonics Threshold",
      },
      {
        harmonic_order: 41,
        default_threshold: 0,
        Alias: "41th Harmonics Threshold",
      },
      {
        harmonic_order: 42,
        default_threshold: 0,
        Alias: "42th Harmonics Threshold",
      },
      {
        harmonic_order: 43,
        default_threshold: 0,
        Alias: "43rd Harmonics Threshold",
      },
      {
        harmonic_order: 44,
        default_threshold: 0,
        Alias: "44th Harmonics Threshold",
      },
      {
        harmonic_order: 45,
        default_threshold: 0,
        Alias: "45th Harmonics Threshold",
      },
      {
        harmonic_order: 46,
        default_threshold: 0,
        Alias: "46th Harmonics Threshold",
      },
      {
        harmonic_order: 47,
        default_threshold: 0,
        Alias: "47th Harmonics Threshold",
      },
      {
        harmonic_order: 48,
        default_threshold: 0,
        Alias: "48th Harmonics Threshold",
      },
      {
        harmonic_order: 49,
        default_threshold: 0,
        Alias: "49th Harmonics Threshold",
      },
      {
        harmonic_order: 50,
        default_threshold: 0,
        Alias: "50th Harmonics Threshold",
      },
    ],
    [],
  );

  const handleMainAddRow = useCallback(() => {
    setMainConditions((prevConditions) => [
      ...prevConditions,
      {
        current_config_id: generateCustomUUID(),
        enable: false,
        pcclowerlimit: "",
        sign: "<= V <",
        pccupperlimit: "",
        isc_il_ratio_lower_limit: "",
        isc_il_sign: "<= V <",
        isc_il_ratio_upper_limit: "",
        individualharmonics: [...defaultHarmonics],
        tddthreshold: "",
      },
    ]);
  }, [generateCustomUUID, defaultHarmonics]);

  const deletecurrentpowerqualityconfigurationcallback = useCallback((res) => {
    console.log("deletecurrentpowerqualityconfiguration", res);
    if (res && res.success && res.success == true) {
      setCurrentHarmonicsSuccess(true);
    } else {
      setCurrentHarmonicsFailed(true);
    }
  }, []);

  // Remove a condition row
  const handleMainRemoveRow = useCallback((index) => {
    setDeleteCurrentIndex(index);
    setDeletecurrentConfirmation(true);
  }, []);

  const handleConfirmdeletecurrentConfirmation = useCallback(() => {
    if (mainconditions.length == 1 && deleteCurrentIndex == 0) {
      setopenAtLeastOneConditionDialog(true);
      return;
    }

    const updatedConditions = mainconditions.filter(
      (_, i) => i !== deleteCurrentIndex,
    );
    console.log("after handleMainRemoveRow-prevconditions", updatedConditions);
    setMainConditions(updatedConditions);
    setDeletecurrentConfirmation(false);
    if (userdetails && userdetails.Projectid && userdetails.Organizationid) {
      if (userdetails?.Projectid == "All") {
        deletecurrentpowerqualityconfiguration(
          mainconditions[deleteCurrentIndex],
          projectname,
          deletecurrentpowerqualityconfigurationcallback,
        );
      } else {
        deletecurrentpowerqualityconfiguration(
          mainconditions[deleteCurrentIndex],
          userdetails.Projectid,
          deletecurrentpowerqualityconfigurationcallback,
        );
      }
    } else {
      console.error("User details are not available or invalid.");
    }
  }, [
    mainconditions,
    deleteCurrentIndex,
    userdetails,
    projectname,
    deletecurrentpowerqualityconfigurationcallback,
  ]);

  const handleVoltageChange = useCallback((event) => {
    setIsVoltageChecked(event.target.checked);
  }, []);

  const handleCurrentChange = useCallback(
    (index, field, value) => {
      if (field == "enable") {
        var updatedConditions = mainconditions.map((condition, i) =>
          i === index
            ? { ...condition, [field]: !value }
            : { ...condition, [field]: false },
        );
      }
      setMainConditions(updatedConditions);
    },
    [mainconditions],
  );

  const handleAddRow = useCallback(() => {
    setConditions((prevConditions) => [
      ...prevConditions,
      {
        voltage_config_id: generateCustomUUID(),
        enable: false,
        pcclowerlimit: "",
        sign: "<= V <",
        pccupperlimit: "",
        individualharmonics: [...defaultHarmonics],
        thdthreshold: "",
      },
    ]);
  }, [generateCustomUUID, defaultHarmonics]);

  const deletepowerqualityconfigurationcallback = useCallback((res) => {
    console.log("res deletepowerqualityconfiguration", res);
    if (res && res.success && res.success == true) {
      setVoltageHarmonicsSuccess(true);
    } else {
      setVoltageHarmonicsFailed(true);
    }
  }, []);

  // Remove a condition row
  const handleRemoveRow = useCallback((index) => {
    setDeleteVoltageIndex(index);
    setDeleteVoltageConfirmation(true);
  }, []);

  const handleConfirmdeletevoltageConfirmation = useCallback(() => {
    if (conditions.length == 1 && deleteVoltageIndex == 0) {
      setopenAtLeastOneConditionDialog(true);
      setDeleteVoltageConfirmation(false);
      return;
    }

    const updatedConditions = conditions.filter(
      (_, i) => i !== deleteVoltageIndex,
    );
    setConditions(updatedConditions);
    setDeleteVoltageConfirmation(false);
    if (userdetails && userdetails.Projectid && userdetails.Organizationid) {
      if (userdetails?.Projectid == "All") {
        deletepowerqualityconfiguration(
          conditions[deleteVoltageIndex],
          projectname,
          deletepowerqualityconfigurationcallback,
        );
      } else {
        deletepowerqualityconfiguration(
          conditions[deleteVoltageIndex],
          userdetails.Projectid,
          deletepowerqualityconfigurationcallback,
        );
      }
    } else {
      console.error("User details are not available or invalid.");
    }
  }, [
    conditions,
    deleteVoltageIndex,
    userdetails,
    projectname,
    deletepowerqualityconfigurationcallback,
  ]);

  const handleAddMainRow = useCallback(() => {
    setMainConditions([
      ...mainconditions,
      {
        current_config_id: generateCustomUUID(),
        enable: false,
        pcclowerlimit: "",
        sign: "",
        pccupperlimit: "",
        subConditions: [
          {
            iscilratiolowerlimit: "",
            sign: "",
            iscilratioupperlimit: "",
            3: "",
            4: "",
            5: "",
            6: "",
            TDD: "",
          },
        ],
      },
    ]);
  }, [mainconditions, generateCustomUUID]);

  // Remove a condition row
  const handleRemoveMainRow = useCallback(
    (index) => {
      if (mainconditions.length == 1 && index == 0) {
        setopenAtLeastOneConditionDialog(true);
        return;
      }

      const updatedConditions = mainconditions.filter((_, i) => i !== index);
      setMainConditions(updatedConditions);
    },
    [mainconditions],
  );

  const addSubCondition = useCallback((conditionIndex) => {
    setMainConditions((prevConditions) => {
      const newConditions = [...prevConditions];
      console.log(
        "conditionIndex-addSubCondition",
        conditionIndex,
        "newConditions",
        newConditions,
      );
      newConditions[conditionIndex].subConditions.push({
        iscilratiolowerlimit: "",
        sign: "",
        iscilratioupperlimit: "",
        3: "",
        4: "",
        5: "",
        6: "",
        TDD: "",
      });
      return newConditions;
    });
  }, []);

  // Function to remove a sub-condition from a specific condition
  const removeSubCondition = useCallback((conditionIndex, subIndex) => {
    setMainConditions((prevConditions) => {
      const newConditions = [...prevConditions];
      newConditions[conditionIndex].subConditions = newConditions[
        conditionIndex
      ].subConditions.filter((_, i) => i !== subIndex);
      return newConditions;
    });
  }, []);

  const handleConfirmationAtLeastOneConditionDialog = useCallback(() => {
    console.log("handleConfirmationAtLeastOneConditionDialog");
    setopenAtLeastOneConditionDialog(false);
  }, []);

  const handleCloseAtLeastOneConditionDialog = useCallback(() => {
    console.log("handleCloseAtLeastOneConditionDialog");
    setopenAtLeastOneConditionDialog(false);
  }, []);

  const handleConfirmationDuplicateAlarm = useCallback(() => {
    setopenDuplicateAlarm(false);
    console.log("pqs");
  }, []);

  const handleCloseDuplicateAlarm = useCallback(() => {
    setopenDuplicateAlarm(false);
  }, []);

  const handleConfirmationAlarmUpdatedandSaved = useCallback(() => {
    console.log("xyz");
    setopenAlarmUpdatedandSaved(false);
  }, []);

  const handleCloseAlarmUpdatedandSaved = useCallback(() => {
    setopenAlarmUpdatedandSaved(false);
    console.log("xyz");
  }, []);

  const getpowerqualityconfigurationcallback = useCallback((res) => {
    console.log("getpowerqualityconfigurationcallback-res", res);
    if (res.data.status == "success") {
      let voltageharmonics = res.data.voltageharmonicsdetails;
      let currentharmonics = res.data.currentharmonicdetails;

      if (Array.isArray(voltageharmonics) && Array.isArray(currentharmonics)) {
        if (voltageharmonics.length == 0 && currentharmonics.length == 0) {
          setConditions([]);
          setMainConditions([]);
          if (
            userdetails &&
            userdetails.Projectid == "All" &&
            projectname == "All"
          ) {
            setEnablefetchData(false);
          } else {
            setEnablefetchData(true);
          }
        } else {
          setConditions(res.data.voltageharmonicsdetails);
          setMainConditions(res.data.currentharmonicdetails);
          setEnablefetchData(false);
        }
      }
    } else {
      setConditions([]);
      setMainConditions([]);
      setNotGetPQData(true);
    }
  }, []);

  const postpowerqualitydatacallback = useCallback((res) => {
    console.log("postpowerqualitydatacallback", res);
    if (res.data.status == "success") {
      setopenAlarmUpdatedandSaved(true);
      if (userdetails?.Projectid == "All") {
        getpowerqualityconfiguration(
          getpowerqualityconfigurationcallback,
          projectname,
        );
      } else {
        getpowerqualityconfiguration(
          getpowerqualityconfigurationcallback,
          userdetails.Projectid,
        );
      }
    } else if (res.data.status == "failure") {
      setopenDuplicateAlarm(true);
      if (userdetails?.Projectid == "All") {
        getpowerqualityconfiguration(
          getpowerqualityconfigurationcallback,
          projectname,
        );
      } else {
        getpowerqualityconfiguration(
          getpowerqualityconfigurationcallback,
          userdetails.Projectid,
        );
      }
    }
  }, []);

  const getSCMaxLoadCurrentThresholdcalback = useCallback((res) => {
    // Implementation here
  }, []);

  const handleClose = useCallback(() => {
    setOpenSave(false);
  }, []);

  const handleSaveChange = useCallback(() => {
    var objecttosave = {
      voltageharmonicsdetails: conditions,
      currentharmonicdetails: mainconditions,
    };
    console.log("HERES objecttosave handleSaveChangeConfirm", objecttosave);
    setOpenSave(true);
  }, [conditions, mainconditions]);

  const handleViewDashboard = useCallback(() => {
    startTransition(() => {
      setViewDashboard(true);
    });
  }, []);

  const handleCancelViewDashboard = useCallback(() => {
    setViewDashboard(false);
  }, []);

  const handleSaveChangeConfirm = useCallback(() => {
    var objecttosave = {
      voltageharmonicsdetails: conditions,
      currentharmonicdetails: mainconditions,
    };
    console.log("objecttosave handleSaveChangeConfirm", objecttosave);

    // Validation logic (keeping original validation)
    for (var i = 0; i < conditions.length; i++) {
      if (
        conditions[i] &&
        conditions[i].hasOwnProperty("individualharmonics") &&
        conditions[i].hasOwnProperty("pcclowerlimit") &&
        conditions[i].hasOwnProperty("pccupperlimit") &&
        conditions[i].hasOwnProperty("thdthreshold")
      ) {
        var voltage_individualharmonics = conditions[i].individualharmonics;
        var pcclowerlimit;
        var pccupperlimit;
        var thdthreshold;
        if (conditions[i].pccupperlimit == "INF") {
          pccupperlimit = 100000;
        } else if (conditions[i].pcclowerlimit == "INF") {
          pcclowerlimit = 100000;
        } else {
          pcclowerlimit = Number(conditions[i].pcclowerlimit);
          pccupperlimit = Number(conditions[i].pccupperlimit);
          thdthreshold = Number(conditions[i].thdthreshold);
        }

        if (
          pcclowerlimit == undefined ||
          pcclowerlimit == null ||
          pccupperlimit == undefined ||
          pccupperlimit == null ||
          thdthreshold == undefined ||
          thdthreshold == null
        ) {
          console.log("Satsifieable 1");
          setInValidLimits(true);
          setOpenSave(false);
          return;
        } else if (
          pcclowerlimit < 0 ||
          pcclowerlimit > 100000 ||
          pccupperlimit < 0 ||
          pccupperlimit > 100000 ||
          thdthreshold < 0 ||
          thdthreshold > 100000
        ) {
          console.log("Satsifieable 2");
          setInValidLimits(true);
          setOpenSave(false);
          return;
        }

        if (pcclowerlimit > pccupperlimit) {
          setInValidLimitsLowerUpper(true);
          setOpenSave(false);
          return;
        }

        for (var j = 0; j < voltage_individualharmonics.length; j++) {
          if (
            Number(voltage_individualharmonics[j]?.default_threshold) ===
              undefined ||
            Number(voltage_individualharmonics[j]?.default_threshold) === null
          ) {
            console.log("Satsifieable 3");
            setInValidLimits(true);
            setOpenSave(false);
            return;
          }

          if (
            Number(voltage_individualharmonics[j]?.default_threshold) < 0 ||
            Number(voltage_individualharmonics[j]?.default_threshold) > 100000
          ) {
            console.log("Satsifieable 4");
            setInValidLimits(true);
            setOpenSave(false);
            return;
          }
        }
      }
    }

    for (var k = 0; k < mainconditions.length; k++) {
      if (
        mainconditions[k] &&
        mainconditions[k].hasOwnProperty("individualharmonics") &&
        mainconditions[k].hasOwnProperty("pcclowerlimit") &&
        mainconditions[k].hasOwnProperty("pccupperlimit") &&
        mainconditions[k].hasOwnProperty("tddthreshold") &&
        mainconditions[k].hasOwnProperty("isc_il_ratio_lower_limit") &&
        mainconditions[k].hasOwnProperty("isc_il_ratio_upper_limit")
      ) {
        var current_individualharmonics = mainconditions[k].individualharmonics;
        var pcclowerlimit;
        var pccupperlimit;
        var tddthreshold;
        var isc_il_ratio_lower_limit;
        var isc_il_ratio_upper_limit;

        if (mainconditions[k].pccupperlimit == "INF") {
          pccupperlimit = 100000;
        } else if (mainconditions[k].pcclowerlimit == "INF") {
          pcclowerlimit = 100000;
        } else if (mainconditions[k].tddthreshold == "INF") {
          tddthreshold = 100000;
        } else if (mainconditions[k]?.isc_il_ratio_lower_limit == "INF") {
          isc_il_ratio_lower_limit = 100000;
        } else if (mainconditions[k]?.isc_il_ratio_upper_limit == "INF") {
          isc_il_ratio_upper_limit = 100000;
        } else {
          pcclowerlimit = Number(mainconditions[k].pcclowerlimit);
          pccupperlimit = Number(mainconditions[k].pccupperlimit);
          tddthreshold = Number(mainconditions[k].tddthreshold);
          isc_il_ratio_lower_limit = Number(
            mainconditions[k]?.isc_il_ratio_lower_limit,
          );
          isc_il_ratio_upper_limit = Number(
            mainconditions[k]?.isc_il_ratio_upper_limit,
          );
        }

        if (
          pcclowerlimit == undefined ||
          pcclowerlimit == null ||
          pccupperlimit == undefined ||
          pccupperlimit == null ||
          tddthreshold == undefined ||
          tddthreshold == null ||
          isc_il_ratio_lower_limit == undefined ||
          isc_il_ratio_lower_limit == null ||
          isc_il_ratio_upper_limit == undefined ||
          isc_il_ratio_upper_limit == null
        ) {
          console.log("Satsifieable 467");
          setInValidLimits(true);
          setOpenSave(false);
          return;
        } else if (
          pcclowerlimit < 0 ||
          pcclowerlimit > 100000 ||
          pccupperlimit < 0 ||
          pccupperlimit > 100000 ||
          tddthreshold < 0 ||
          tddthreshold > 100000 ||
          isc_il_ratio_lower_limit < 0 ||
          isc_il_ratio_lower_limit > 100000 ||
          isc_il_ratio_upper_limit < 0 ||
          isc_il_ratio_upper_limit > 100000
        ) {
          console.log("Satsifieable 5");
          setInValidLimits(true);
          setOpenSave(false);
          return;
        }

        if (
          pcclowerlimit > pccupperlimit ||
          isc_il_ratio_lower_limit > isc_il_ratio_upper_limit
        ) {
          setInValidLimitsLowerUpper(true);
          setOpenSave(false);
          return;
        }

        for (var m = 0; m < current_individualharmonics.length; m++) {
          if (
            !current_individualharmonics[m] ||
            current_individualharmonics[m]?.default_threshold == undefined ||
            current_individualharmonics[m]?.default_threshold == null
          ) {
            console.log("Satsifieable 7");
            setInValidLimits(true);
            setOpenSave(false);
            return;
          }

          if (
            current_individualharmonics[m]?.default_threshold < 0 ||
            current_individualharmonics[m]?.default_threshold > 100000
          ) {
            console.log("Satsifieable 8");
            setInValidLimits(true);
            setOpenSave(false);
            return;
          }
        }
      }
    }

    if (userdetails && userdetails.Projectid && userdetails.Organizationid) {
      if (userdetails && userdetails.Projectid == "All") {
        postpowerqualityconfiguration(
          objecttosave,
          projectname,
          postpowerqualitydatacallback,
        );
      } else if (userdetails) {
        postpowerqualityconfiguration(
          objecttosave,
          userdetails.Projectid,
          postpowerqualitydatacallback,
        );
      }
    } else {
      console.error("User details are not available or invalid.");
    }

    setOpenSave(false);
  }, [
    conditions,
    mainconditions,
    userdetails,
    projectname,
    postpowerqualitydatacallback,
  ]);

  useEffect(() => {
    if (overviewstate) {
      setPagesize(323);
    } else {
      setPagesize(288);
    }
  }, [overviewstate]);

  // Optimize the main useEffect with proper dependency management
  useEffect(() => {
    if (userdetails?.Projectid && userdetails?.Organizationid) {
      getdevicetagsModified(assetcallback);

      if (userdetails.Projectid === "All") {
        getpowerqualityconfiguration(
          getpowerqualityconfigurationcallback,
          projectname,
        );
      } else {
        getpowerqualityconfiguration(
          getpowerqualityconfigurationcallback,
          userdetails.Projectid,
        );
      }
    }

    if (logindetails?.Organizationid && projectId) {
      getdashboarlist(
        logindetails.Organizationid,
        projectId,
        "All",
        restcallbackdashboard,
      );
    }
  }, [
    userdetails?.Projectid,
    userdetails?.Organizationid,
    projectname,
    logindetails?.Organizationid,
    projectId,
  ]);

  const isValidLength = useCallback((value, minLength, maxLength) => {
    return value.length >= minLength && value.length <= maxLength;
  }, []);

  const isValidNumber = useCallback((value, minNumber, maxNumber) => {
    return (
      Number(value) >= Number(minNumber) && Number(value) <= Number(maxNumber)
    );
  }, []);

  // Memoize table styles to prevent recreation
  const tableStyles = useMemo(
    () => ({
      tableContainer: {
        width: "100%",
        paddingLeft: "0px",
        backgroundColor: "var(--secondary-backgroundLK)",
        paddingRight: "0px",
        height: `calc(100vh - ${pagesize}px)-200px`,
      },
      tableCellHeader: {
        padding: "0px",
        fontSize: "12px",
        fontWeight: 400,
        color: "var(--grey-variation-tableLK)",
        backgroundColor: "var(--secondary-backgroundLK)",
      },
      textFieldStyle: {
        width: "94px",
        "& .MuiInputBase-input:focus": {
          color: "#008CD7",
        },
        "& .MuiInputBase-root": {
          fontFamily: "Roboto",
          fontSize: "24px",
          fontWeight: "700",
          color: themechange === "light" ? "#3C3C3C" : "#FFFFFF",
        },
        "& .MuiInput-root .MuiInputBase-input": {},
        "& .MuiInputBase-root::before": {
          borderBottom: `1px solid ${themechange === "light" ? "#3C3C3C" : "#FFFFFF"}`,
        },
        "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
          borderBottom: "2px solid #008CD7",
        },
        "& .MuiInputBase-root::after": {
          borderBottom: "2px solid #008CD7",
        },
      },
    }),
    [pagesize, themechange],
  );

  return (
    <>
      {viewDashboard == false && (
        <Box
          className="compliance-config"
          sx={{ height: "100%", boxSizing: "border-box", width: "100%" }}
        >
          <Box
            sx={{
              padding: "0px",
              height: "calc(100% - 0px)",
              width: "100%",
              boxSizing: "border-box",
            }}
          >
            <Box
              sx={{
                padding: "0px",
                width: "100%",
                height: "7%",
                boxSizing: "border-box",
                display: "flex",
                gap: "8px",
              }}
            >
              {enablefetchData && (
                <CustomButton
                  onClick={handlefetchData}
                  buttonText={"Fetch Power Quality Parameters Details"}
                  width={"350px"}
                />
              )}
              <Box sx={{ flexGrow: 1 }}></Box>
              <CustomButton
                onClick={handleViewDashboard}
                buttonText={
                  isPending ? "Loading Dashboard..." : "View Dashboard"
                }
                width={"200px"}
              />
              <CustomButton
                onClick={handleConfigureDashboard}
                buttonText={"Configure Dashboard"}
                width={"200px"}
              />
              <CustomButton
                onClick={handleSaveChange}
                buttonText={"Save"}
                width={"12px"}
              />
            </Box>

            <Box
              sx={{
                boxSizing: "border-box",
                padding: "8px",
                background: "var(--PrimaryBackground)",
                height: "calc(93%)",
                marginBottom: "0px",
                overflow: "auto",
              }}
            >
              <Typography
                sx={{
                  fontSize: "16px",
                  fontFamily: "Roboto",
                  color: themechange === "light" ? "#7e7e7e" : "#c1c1c1",
                  fontWeight: 400,
                  marginLeft: "0px",
                  marginTop: "6px",
                  textAlign: "left",
                }}
              >
                Note:- PCC: Power Common Coupling Point, Isc: Short-Circuit
                Current and IL:Maximum Load Current
              </Typography>

              <Typography
                sx={{
                  fontSize: "16px",
                  fontFamily: "Roboto",
                  color: themechange === "light" ? "#7e7e7e" : "#c1c1c1",
                  fontWeight: 400,
                  marginLeft: "0px",
                  marginTop: "14px",
                  textAlign: "left",
                }}
              >
                Voltage Harmonic Details
              </Typography>
              <Box
                className="config-form-box"
                sx={{
                  padding: "4px 4px 4px 0px",
                  width: "100%",
                  boxSizing: "border-box",
                  marginTop: "12px",
                }}
              >
                <TableContainer
                  component={Paper}
                  sx={tableStyles.tableContainer}
                  className="styled-scrollbar"
                  elevation={0}
                >
                  <Table stickyHeader sx={{ width: "100%" }} size="large">
                    <TableHead sx={{ width: "100%" }}>
                      <TableRow sx={{ border: "0px" }}>
                        <TableCell
                          align="left"
                          sx={{
                            ...tableStyles.tableCellHeader,
                            paddingLeft: "10px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                            }}
                          >
                            <CustomTableHeading children={"Enabled"} />
                          </div>
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={tableStyles.tableCellHeader}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                            }}
                          >
                            <CustomTableHeading
                              children={"Bus Voltage Lower Limit PCC"}
                            />
                            <span style={{ color: "#DC272D" }}>*</span>
                          </div>
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={tableStyles.tableCellHeader}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                            }}
                          >
                            <CustomTableHeading children={"Sign"} />
                            <span style={{ color: "#DC272D" }}>*</span>
                          </div>
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={tableStyles.tableCellHeader}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                            }}
                          >
                            <CustomTableHeading
                              children={"Bus Voltage Upper Limit PCC"}
                            />
                            <span style={{ color: "#DC272D" }}>*</span>
                          </div>
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={tableStyles.tableCellHeader}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                            }}
                          >
                            <CustomTableHeading
                              children={"Individual Harmonic(%) Threshold"}
                            />
                            <span style={{ color: "#DC272D" }}>*</span>
                          </div>
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={tableStyles.tableCellHeader}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                            }}
                          >
                            <CustomTableHeading
                              children={
                                "Total Harmonic Distortion(%) Threshold"
                              }
                            />
                            <span style={{ color: "#DC272D" }}>*</span>
                          </div>
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={tableStyles.tableCellHeader}
                        >
                          <CustomTableHeading children={"Delete"} />
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={tableStyles.tableCellHeader}
                        >
                          <CustomTableHeading children={"Add"} />
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {Array.isArray(conditions) && conditions.length > 0 ? (
                        conditions.map((condition, index) =>
                          condition &&
                          condition.hasOwnProperty("enable") &&
                          condition.hasOwnProperty("pcclowerlimit") &&
                          condition.hasOwnProperty("sign") &&
                          condition.hasOwnProperty("pccupperlimit") &&
                          condition.hasOwnProperty("thdthreshold") &&
                          condition.hasOwnProperty("individualharmonics") ? (
                            <TableRow
                              key={index}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                                height: "9px",
                                "& > *": {
                                  borderBottom:
                                    "1px solid var(--table-boarder-line)",
                                },
                              }}
                            >
                              <TableCell
                                component="th"
                                scope="row"
                                sx={{
                                  padding: "0px",
                                  paddingLeft: "10px",
                                  fontSize: "24px",
                                  fontWeight: 400,
                                  color: "var(--grey-variation-tablerowsLK)",
                                  paddingTop: "5px",
                                  paddingBottom: "5px",
                                }}
                              >
                                <input
                                  type="radio"
                                  checked={condition?.enable == true}
                                  onChange={(e) =>
                                    handleConditionChange(
                                      index,
                                      "",
                                      "enable",
                                      e.target.value,
                                    )
                                  }
                                />
                              </TableCell>
                              <TableCell
                                component="th"
                                scope="row"
                                sx={{
                                  padding: "0px",
                                  fontSize: "24px",
                                  fontWeight: 400,
                                  color: "var(--grey-variation-tablerowsLK)",
                                  paddingTop: "5px",
                                  paddingBottom: "5px",
                                }}
                              >
                                <TextField
                                  label=""
                                  value={condition?.pcclowerlimit}
                                  variant="standard"
                                  type="number"
                                  onChange={(e) =>
                                    handleConditionChange(
                                      index,
                                      "",
                                      "pcclowerlimit",
                                      e.target.value,
                                    )
                                  }
                                  sx={tableStyles.textFieldStyle}
                                />
                              </TableCell>
                              <TableCell
                                component="th"
                                scope="row"
                                sx={{
                                  padding: "0px",
                                  fontSize: "24px",
                                  fontWeight: 400,
                                  color: "var(--grey-variation-tablerowsLK)",
                                  paddingTop: "5px",
                                  paddingBottom: "5px",
                                }}
                              >
                                <TextField
                                  label=""
                                  value={condition?.sign}
                                  variant="standard"
                                  type="string"
                                  onChange={""}
                                  sx={tableStyles.textFieldStyle}
                                />
                              </TableCell>
                              <TableCell
                                component="th"
                                scope="row"
                                sx={{
                                  padding: "0px",
                                  fontSize: "24px",
                                  fontWeight: 400,
                                  color: "var(--grey-variation-tablerowsLK)",
                                  paddingTop: "5px",
                                  paddingBottom: "5px",
                                }}
                              >
                                <TextField
                                  label=""
                                  value={condition?.pccupperlimit}
                                  variant="standard"
                                  type="number"
                                  onChange={(e) =>
                                    handleConditionChange(
                                      index,
                                      "",
                                      "pccupperlimit",
                                      e.target.value,
                                    )
                                  }
                                  sx={tableStyles.textFieldStyle}
                                />
                              </TableCell>
                              <TableCell
                                component="th"
                                scope="row"
                                sx={{
                                  padding: "0px",
                                  fontSize: "12px",
                                  fontWeight: 400,
                                  color: "var(--grey-variation-tablerowsLK)",
                                }}
                              >
                                <CustomActionButton
                                  buttonText={"View Harmonics"}
                                  onClick={() => handleOpenDialog(index)}
                                />
                                <Dialog
                                  open={openDialogIndex === index}
                                  onClose={handleCloseDialog}
                                  fullWidth
                                  maxWidth="xl"
                                  BackdropProps={{
                                    sx: {
                                      backgroundColor:
                                        themechange == "light"
                                          ? "rgba(0,0,0,0.3)"
                                          : "rgba(255,255,255,0.3)",
                                    },
                                  }}
                                  sx={{
                                    "& .MuiDialog-paper": {
                                      height: "38vh",
                                      borderTopLeftRadius: "40px",
                                      borderTopRightRadius: "40px",
                                      overflow: "auto",
                                      backgroundColor:
                                        themechange == "light"
                                          ? "#FFFFFF"
                                          : "#19191B",
                                    },
                                  }}
                                >
                                  <DialogTitle
                                    sx={{
                                      color: "#FFFFFF",
                                      backgroundColor: "#005C8E",
                                      margin: "5px",
                                      borderRadius: "100px",
                                    }}
                                  >
                                    Individual Harmonics Table
                                  </DialogTitle>
                                  <DialogContent
                                    sx={{
                                      width: "100%",
                                      height: "100%",
                                      backgroundColor:
                                        "var(--secondary-backgroundLK)",
                                      overflow: "auto",
                                      position: "relative",
                                    }}
                                  >
                                    <TableContainer
                                      component={Paper}
                                      sx={{
                                        width: "100%",
                                        overflowX: "scroll",
                                        overflowY: "hidden",
                                        paddingLeft: "0px",
                                        paddingRight: "0px",
                                        backgroundColor:
                                          "var(--secondary-backgroundLK)",
                                        height: "100%",
                                        "&::-webkit-scrollbar": {
                                          width: "4px",
                                          height: "4px",
                                        },
                                        "&::-webkit-scrollbar-thumb": {
                                          background: "#7e7e7e",
                                          borderRadius: "5px",
                                          height: "auto",
                                        },
                                        "&::-webkit-scrollbar-track": {
                                          borderRadius: "0px",
                                          background:
                                            themechange === "dark"
                                              ? "#3c3c3c"
                                              : "#c1c1c1",
                                        },
                                      }}
                                      className="styled-scrollbar"
                                      elevation={0}
                                    >
                                      <Table
                                        sx={{ width: "100%" }}
                                        size="large"
                                      >
                                        <TableHead
                                          sx={{ border: "none", width: "100%" }}
                                        >
                                          <TableRow
                                            sx={{
                                              border: "0px",
                                              border: "none",
                                            }}
                                          >
                                            {condition?.individualharmonics !=
                                              undefined &&
                                            condition?.individualharmonics !=
                                              null ? (
                                              condition.individualharmonics.map(
                                                (
                                                  currentindividualharmonic,
                                                  individualharmonicsindex,
                                                ) => {
                                                  return (
                                                    <TableCell
                                                      key={
                                                        individualharmonicsindex
                                                      }
                                                      align="left"
                                                      sx={{
                                                        fontSize: "14px",
                                                        fontWeight: 400,
                                                        color:
                                                          themechange == "light"
                                                            ? "#000000 !important"
                                                            : "#ffffff !important",
                                                        border: "none",
                                                      }}
                                                    >
                                                      <Typography
                                                        style={{
                                                          fontSize: "14px",
                                                          fontWeight: 700,
                                                          color:
                                                            themechange ==
                                                            "light"
                                                              ? "#000000 !important"
                                                              : "#ffffff !important",
                                                          fontFamily: "Roboto",
                                                          fontWeight: 700,
                                                          fontSize: "12px",
                                                          lineHeight: "14.06px",
                                                          textAlign: "left",
                                                        }}
                                                      >
                                                        {
                                                          currentindividualharmonic.harmonic_order
                                                        }
                                                      </Typography>
                                                    </TableCell>
                                                  );
                                                },
                                              )
                                            ) : (
                                              <></>
                                            )}
                                          </TableRow>
                                          <TableRow
                                            sx={{
                                              border: "0px",
                                              border: "none",
                                            }}
                                          >
                                            {condition?.individualharmonics !=
                                              undefined &&
                                            condition?.individualharmonics !=
                                              null ? (
                                              condition.individualharmonics.map(
                                                (
                                                  currentindividualharmonic,
                                                  individualharmonicsindex,
                                                ) => {
                                                  return (
                                                    <TableCell
                                                      key={
                                                        individualharmonicsindex
                                                      }
                                                      contentEditable
                                                      suppressHydrationWarning={
                                                        true
                                                      }
                                                      onInput={(e) =>
                                                        handleConditionChange(
                                                          index,
                                                          individualharmonicsindex,
                                                          "individualharmonics:Alias",
                                                          e.target.textContent,
                                                        )
                                                      }
                                                      align="left"
                                                      sx={{
                                                        fontSize: "14px",
                                                        fontWeight: 400,
                                                        color:
                                                          themechange == "light"
                                                            ? "#000000 !important"
                                                            : "#ffffff !important",
                                                        border: "none",
                                                      }}
                                                    >
                                                      <Typography
                                                        style={{
                                                          fontSize: "14px",
                                                          fontWeight: 700,
                                                          color:
                                                            themechange ==
                                                            "light"
                                                              ? "#000000 !important"
                                                              : "#ffffff !important",
                                                          fontFamily: "Roboto",
                                                          fontWeight: 700,
                                                          fontSize: "12px",
                                                          lineHeight: "14.06px",
                                                          textAlign: "left",
                                                        }}
                                                      >
                                                        {
                                                          currentindividualharmonic.Alias
                                                        }
                                                      </Typography>
                                                    </TableCell>
                                                  );
                                                },
                                              )
                                            ) : (
                                              <></>
                                            )}
                                          </TableRow>
                                        </TableHead>
                                        <TableBody>
                                          <TableRow
                                            key={index}
                                            sx={{
                                              "&:last-child td, &:last-child th":
                                                { border: 0 },
                                              height: "9px",
                                              "& > *": {
                                                borderBottom:
                                                  "1px solid var(--table-boarder-line)",
                                              },
                                            }}
                                          >
                                            {condition.individualharmonics.map(
                                              (
                                                currentindividualharmonic,
                                                conditionindex,
                                              ) => {
                                                return (
                                                  <TableCell
                                                    key={conditionindex}
                                                    contentEditable
                                                    suppressHydrationWarning={
                                                      true
                                                    }
                                                    onInput={(e) =>
                                                      handleConditionChange(
                                                        index,
                                                        conditionindex,
                                                        "individualharmonics:default_threshold",
                                                        e.target.textContent,
                                                      )
                                                    }
                                                    component="th"
                                                    scope="row"
                                                    sx={{
                                                      width: "9%",
                                                      paddingTop: "10px",
                                                      paddingBottom: "10px",
                                                      fontSize: "14px",
                                                      fontWeight: 400,
                                                      color:
                                                        themechange == "light"
                                                          ? "#000000 !important"
                                                          : "#ffffff !important",
                                                      border: "none",
                                                    }}
                                                  >
                                                    <Typography
                                                      className="emission-config-metric"
                                                      style={{
                                                        fontSize: "12px",
                                                        fontWeight: 400,
                                                        color:
                                                          themechange == "light"
                                                            ? "#000000 !important"
                                                            : "#ffffff !important",
                                                        whiteSpace: "nowrap",
                                                        textOverflow:
                                                          "ellipsis",
                                                        overflow: "hidden",
                                                      }}
                                                    >
                                                      {
                                                        currentindividualharmonic?.default_threshold
                                                      }
                                                    </Typography>
                                                  </TableCell>
                                                );
                                              },
                                            )}
                                          </TableRow>
                                        </TableBody>
                                      </Table>
                                    </TableContainer>
                                  </DialogContent>
                                  <DialogActions
                                    sx={{ justifyContent: "center" }}
                                  >
                                    <CustomCancelButton
                                      onClick={handleCloseDialog}
                                      buttonText={"Cancel"}
                                    ></CustomCancelButton>
                                  </DialogActions>
                                </Dialog>
                              </TableCell>
                              <TableCell
                                component="th"
                                scope="row"
                                sx={{
                                  padding: "0px",
                                  fontSize: "12px",
                                  fontWeight: 400,
                                  color: "var(--grey-variation-tablerowsLK)",
                                  paddingTop: "5px",
                                  paddingBottom: "5px",
                                }}
                              >
                                <TextField
                                  label=""
                                  value={condition?.thdthreshold}
                                  variant="standard"
                                  type="number"
                                  onChange={(e) =>
                                    handleConditionChange(
                                      index,
                                      "",
                                      "thdthreshold",
                                      e.target.value,
                                    )
                                  }
                                  sx={tableStyles.textFieldStyle}
                                />
                              </TableCell>
                              <TableCell
                                component="th"
                                scope="row"
                                sx={{
                                  padding: "0px",
                                  fontSize: "12px",
                                  fontWeight: 400,
                                  color: "var(--grey-variation-tablerowsLK)",
                                  paddingTop: "2px",
                                  paddingBottom: "2px",
                                }}
                              >
                                <Button
                                  sx={{
                                    width: "20px",
                                    minWidth: "unset",
                                    height: "20px",
                                    margin: "0px",
                                    padding: "0px",
                                    fontSize: "16px",
                                    fontFamily: "Roboto",
                                    textTransform: "capitalize",
                                    backgroundColor:
                                      "var(--SecondaryBackground)",
                                    boxShadow: "none",
                                  }}
                                  variant="text"
                                  onClick={() => handleRemoveRow(index)}
                                  disableTouchRipple
                                  elevation={0}
                                >
                                  <LK_Delete
                                    color={"#005C8E"}
                                    width={"20px"}
                                    height={"20px"}
                                  />
                                </Button>
                              </TableCell>
                              <TableCell
                                component="th"
                                scope="row"
                                sx={{
                                  alignItems: "baseline",
                                  padding: "0px",
                                  fontSize: "12px",
                                  fontWeight: 400,
                                  color: "var(--grey-variation-tablerowsLK)",
                                  paddingTop: "2px",
                                  paddingBottom: "2px",
                                }}
                              >
                                {
                                  <div
                                    style={{
                                      display: "flex",
                                      marginTop: 0,
                                      paddingTop: 0,
                                    }}
                                  >
                                    <CustomActionButton
                                      buttonText={"Add Row"}
                                      onClick={handleAddRow}
                                    />
                                  </div>
                                }
                              </TableCell>
                            </TableRow>
                          ) : (
                            <></>
                          ),
                        )
                      ) : (
                        <></>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>

              <Typography
                sx={{
                  fontSize: "16px",
                  fontFamily: "Roboto",
                  color: themechange === "light" ? "#7e7e7e" : "#c1c1c1",
                  fontWeight: 400,
                  marginLeft: "14px",
                  marginTop: "14px",
                  textAlign: "left",
                }}
              >
                Current Harmonic Details
              </Typography>
              <Box
                className="config-form-box"
                sx={{
                  padding: "4px 4px 4px 0px",
                  width: "100%",
                  boxSizing: "border-box",
                  marginTop: "12px",
                }}
              >
                <TableContainer
                  component={Paper}
                  sx={tableStyles.tableContainer}
                  className="styled-scrollbar"
                  elevation={0}
                >
                  <Table stickyHeader sx={{ width: "100%" }} size="large">
                    <TableHead sx={{ width: "100%" }}>
                      <TableRow sx={{ border: "0px" }}>
                        <TableCell
                          align="left"
                          sx={{
                            ...tableStyles.tableCellHeader,
                            paddingLeft: "10px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                            }}
                          >
                            <CustomTableHeading children={"Enabled"} />
                          </div>
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={tableStyles.tableCellHeader}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                            }}
                          >
                            <CustomTableHeading
                              children={"Bus Voltage Lower Limit PCC"}
                            />
                            <span
                              style={{ color: "#DC272D", marginLeft: "5px" }}
                            >
                              *
                            </span>
                          </div>
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={tableStyles.tableCellHeader}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                            }}
                          >
                            <CustomTableHeading children={"Sign"} />
                            <span
                              style={{ color: "#DC272D", marginLeft: "5px" }}
                            >
                              *
                            </span>
                          </div>
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={tableStyles.tableCellHeader}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                            }}
                          >
                            <CustomTableHeading
                              children={"Bus Voltage Upper Limit PCC"}
                            />
                            <span
                              style={{ color: "#DC272D", marginLeft: "5px" }}
                            >
                              *
                            </span>
                          </div>
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={tableStyles.tableCellHeader}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                            }}
                          >
                            <CustomTableHeading
                              children={"Isc/IL ratio Lower Limit"}
                            />
                            <span
                              style={{ color: "#DC272D", marginLeft: "5px" }}
                            >
                              *
                            </span>
                          </div>
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={tableStyles.tableCellHeader}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                            }}
                          >
                            <CustomTableHeading children={"Sign"} />
                            <span
                              style={{ color: "#DC272D", marginLeft: "5px" }}
                            >
                              *
                            </span>
                          </div>
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={tableStyles.tableCellHeader}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                            }}
                          >
                            <CustomTableHeading
                              children={"Isc/IL ratio Upper Limit"}
                            />
                            <span
                              style={{ color: "#DC272D", marginLeft: "5px" }}
                            >
                              *
                            </span>
                          </div>
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={tableStyles.tableCellHeader}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                            }}
                          >
                            <CustomTableHeading
                              children={"Individual Harmonic(%) Threshold"}
                            />
                            <span
                              style={{ color: "#DC272D", marginLeft: "5px" }}
                            >
                              *
                            </span>
                          </div>
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={tableStyles.tableCellHeader}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                            }}
                          >
                            <CustomTableHeading
                              children={"Total Demand Distortion(%) Threshold"}
                            />
                            <span
                              style={{ color: "#DC272D", marginLeft: "5px" }}
                            >
                              *
                            </span>
                          </div>
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={tableStyles.tableCellHeader}
                        >
                          <CustomTableHeading children={"Delete"} />
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={tableStyles.tableCellHeader}
                        >
                          <CustomTableHeading children={"Add"} />
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {Array.isArray(mainconditions) &&
                      mainconditions.length > 0 ? (
                        mainconditions.map((maincondition, index) =>
                          maincondition &&
                          maincondition.hasOwnProperty("enable") &&
                          maincondition.hasOwnProperty("pcclowerlimit") &&
                          maincondition.hasOwnProperty("sign") &&
                          maincondition.hasOwnProperty("pccupperlimit") &&
                          maincondition.hasOwnProperty(
                            "isc_il_ratio_lower_limit",
                          ) &&
                          maincondition.hasOwnProperty("isc_il_sign") &&
                          maincondition.hasOwnProperty(
                            "isc_il_ratio_upper_limit",
                          ) &&
                          maincondition.hasOwnProperty("individualharmonics") &&
                          maincondition.hasOwnProperty("tddthreshold") ? (
                            <TableRow
                              key={index}
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                                height: "9px",
                                "& > *": {
                                  borderBottom:
                                    "1px solid var(--table-boarder-line)",
                                },
                              }}
                            >
                              <TableCell
                                component="th"
                                scope="row"
                                sx={{
                                  padding: "0px",
                                  paddingLeft: "10px",
                                  fontSize: "24px",
                                  fontWeight: 400,
                                  color: "var(--grey-variation-tablerowsLK)",
                                  paddingTop: "5px",
                                  paddingBottom: "5px",
                                }}
                              >
                                <input
                                  type="radio"
                                  checked={maincondition?.enable == true}
                                  onChange={(e) =>
                                    handleMainConditionChange(
                                      index,
                                      "",
                                      "enable",
                                      e.target.value,
                                    )
                                  }
                                />
                              </TableCell>
                              <TableCell
                                component="th"
                                scope="row"
                                sx={{
                                  padding: "0px",
                                  fontSize: "24px",
                                  fontWeight: 400,
                                  color: "var(--grey-variation-tablerowsLK)",
                                  paddingTop: "5px",
                                  paddingBottom: "5px",
                                }}
                              >
                                <TextField
                                  label=""
                                  value={maincondition?.pcclowerlimit}
                                  variant="standard"
                                  type="number"
                                  onChange={(e) =>
                                    handleMainConditionChange(
                                      index,
                                      "",
                                      "pcclowerlimit",
                                      e.target.value,
                                    )
                                  }
                                  sx={tableStyles.textFieldStyle}
                                />
                              </TableCell>
                              <TableCell
                                component="th"
                                scope="row"
                                sx={{
                                  padding: "0px",
                                  fontSize: "24px",
                                  fontWeight: 400,
                                  color: "var(--grey-variation-tablerowsLK)",
                                  paddingTop: "5px",
                                  paddingBottom: "5px",
                                }}
                              >
                                <TextField
                                  label=""
                                  value={maincondition?.sign}
                                  variant="standard"
                                  type="string"
                                  onChange={""}
                                  sx={tableStyles.textFieldStyle}
                                />
                              </TableCell>
                              <TableCell
                                component="th"
                                scope="row"
                                sx={{
                                  padding: "0px",
                                  fontSize: "24px",
                                  fontWeight: 400,
                                  color: "var(--grey-variation-tablerowsLK)",
                                  paddingTop: "5px",
                                  paddingBottom: "5px",
                                }}
                              >
                                <TextField
                                  label=""
                                  value={maincondition?.pccupperlimit}
                                  variant="standard"
                                  type="number"
                                  onChange={(e) =>
                                    handleMainConditionChange(
                                      index,
                                      "",
                                      "pccupperlimit",
                                      e.target.value,
                                    )
                                  }
                                  sx={tableStyles.textFieldStyle}
                                />
                              </TableCell>
                              <TableCell
                                component="th"
                                scope="row"
                                sx={{
                                  padding: "0px",
                                  fontSize: "24px",
                                  fontWeight: 400,
                                  color: "var(--grey-variation-tablerowsLK)",
                                  paddingTop: "5px",
                                  paddingBottom: "5px",
                                }}
                              >
                                <TextField
                                  label=""
                                  value={
                                    maincondition?.isc_il_ratio_lower_limit
                                  }
                                  variant="standard"
                                  type="number"
                                  onChange={(e) =>
                                    handleMainConditionChange(
                                      index,
                                      "",
                                      "isc_il_ratio_lower_limit",
                                      e.target.value,
                                    )
                                  }
                                  sx={tableStyles.textFieldStyle}
                                />
                              </TableCell>
                              <TableCell
                                component="th"
                                scope="row"
                                sx={{
                                  padding: "0px",
                                  fontSize: "24px",
                                  fontWeight: 400,
                                  color: "var(--grey-variation-tablerowsLK)",
                                  paddingTop: "5px",
                                  paddingBottom: "5px",
                                }}
                              >
                                <TextField
                                  label=""
                                  value={maincondition?.isc_il_sign}
                                  variant="standard"
                                  type="string"
                                  onChange={""}
                                  sx={tableStyles.textFieldStyle}
                                />
                              </TableCell>
                              <TableCell
                                component="th"
                                scope="row"
                                sx={{
                                  padding: "0px",
                                  fontSize: "24px",
                                  fontWeight: 400,
                                  color: "var(--grey-variation-tablerowsLK)",
                                  paddingTop: "5px",
                                  paddingBottom: "5px",
                                }}
                              >
                                <TextField
                                  label=""
                                  value={
                                    maincondition?.isc_il_ratio_upper_limit
                                  }
                                  variant="standard"
                                  type="number"
                                  onChange={(e) =>
                                    handleMainConditionChange(
                                      index,
                                      "",
                                      "isc_il_ratio_upper_limit",
                                      e.target.value,
                                    )
                                  }
                                  sx={tableStyles.textFieldStyle}
                                />
                              </TableCell>
                              <TableCell
                                component="th"
                                scope="row"
                                sx={{
                                  padding: "0px",
                                  fontSize: "12px",
                                  fontWeight: 400,
                                  color: "var(--grey-variation-tablerowsLK)",
                                }}
                              >
                                <CustomActionButton
                                  buttonText={"View Harmonics"}
                                  onClick={() =>
                                    handleOpenCurrentHarmonicDialog(index)
                                  }
                                />
                                <Dialog
                                  open={
                                    openDialogCurrentHarmonicIndex === index
                                  }
                                  onClose={handleCloseCurrentHarmonicDialog}
                                  fullWidth
                                  maxWidth="xl"
                                  BackdropProps={{
                                    sx: {
                                      backgroundColor:
                                        themechange == "light"
                                          ? "rgba(0,0,0,0.3)"
                                          : "rgba(255,255,255,0.3)",
                                    },
                                  }}
                                  sx={{
                                    "& .MuiDialog-paper": {
                                      height: "38vh",
                                      borderTopLeftRadius: "40px",
                                      borderTopRightRadius: "40px",
                                      overflow: "auto",
                                      backgroundColor:
                                        themechange == "light"
                                          ? "#FFFFFF"
                                          : "#19191B",
                                    },
                                  }}
                                >
                                  <DialogTitle
                                    sx={{
                                      color: "#FFFFFF",
                                      backgroundColor: "#005C8E",
                                      margin: "5px",
                                      borderRadius: "100px",
                                    }}
                                  >
                                    Individual Harmonics Table
                                  </DialogTitle>
                                  <DialogContent
                                    sx={{
                                      width: "100%",
                                      height: "100%",
                                      backgroundColor:
                                        "var(--secondary-backgroundLK)",
                                      overflow: "auto",
                                      position: "relative",
                                    }}
                                  >
                                    <TableContainer
                                      component={Paper}
                                      sx={{
                                        width: "100%",
                                        overflowX: "scroll",
                                        overflowY: "hidden",
                                        paddingLeft: "0px",
                                        paddingRight: "0px",
                                        backgroundColor:
                                          "var(--secondary-backgroundLK)",
                                        height: "100%",
                                        "&::-webkit-scrollbar": {
                                          width: "4px",
                                          height: "4px",
                                        },
                                        "&::-webkit-scrollbar-thumb": {
                                          background: "#7e7e7e",
                                          borderRadius: "5px",
                                          height: "auto",
                                        },
                                        "&::-webkit-scrollbar-track": {
                                          borderRadius: "0px",
                                          background:
                                            themechange === "dark"
                                              ? "#3c3c3c"
                                              : "#c1c1c1",
                                        },
                                      }}
                                      className="styled-scrollbar"
                                      elevation={0}
                                    >
                                      <Table
                                        sx={{ width: "100%" }}
                                        size="large"
                                      >
                                        <TableHead
                                          sx={{ border: "none", width: "100%" }}
                                        >
                                          <TableRow
                                            sx={{
                                              border: "0px",
                                              border: "none",
                                            }}
                                          >
                                            {maincondition?.individualharmonics !=
                                              undefined &&
                                            maincondition?.individualharmonics !=
                                              null ? (
                                              maincondition.individualharmonics.map(
                                                (
                                                  maincurrentindividualharmonic,
                                                  individualharmonicsindex,
                                                ) => {
                                                  return (
                                                    <TableCell
                                                      key={
                                                        individualharmonicsindex
                                                      }
                                                      align="left"
                                                      sx={{
                                                        fontSize: "14px",
                                                        fontWeight: 400,
                                                        border: "none",
                                                        color:
                                                          themechange == "light"
                                                            ? "#000000 !important"
                                                            : "#ffffff !important",
                                                      }}
                                                    >
                                                      <Typography
                                                        style={{
                                                          fontSize: "14px",
                                                          fontWeight: 700,
                                                          color:
                                                            themechange ==
                                                            "light"
                                                              ? "#000000 !important"
                                                              : "#ffffff !important",
                                                          fontFamily: "Roboto",
                                                          fontWeight: 700,
                                                          fontSize: "12px",
                                                          lineHeight: "14.06px",
                                                          textAlign: "left",
                                                        }}
                                                      >
                                                        {
                                                          maincurrentindividualharmonic.harmonic_order
                                                        }
                                                      </Typography>
                                                    </TableCell>
                                                  );
                                                },
                                              )
                                            ) : (
                                              <></>
                                            )}
                                          </TableRow>
                                          <TableRow
                                            sx={{
                                              border: "0px",
                                              border: "none",
                                            }}
                                          >
                                            {maincondition?.individualharmonics !=
                                              undefined &&
                                            maincondition?.individualharmonics !=
                                              null ? (
                                              maincondition.individualharmonics.map(
                                                (
                                                  maincurrentindividualharmonic,
                                                  individualharmonicsindex,
                                                ) => {
                                                  return (
                                                    <TableCell
                                                      key={
                                                        individualharmonicsindex
                                                      }
                                                      contentEditable
                                                      suppressHydrationWarning={
                                                        true
                                                      }
                                                      onInput={(e) =>
                                                        handleMainConditionChange(
                                                          index,
                                                          individualharmonicsindex,
                                                          "individualharmonics:Alias",
                                                          e.target.textContent,
                                                        )
                                                      }
                                                      align="left"
                                                      sx={{
                                                        fontSize: "14px",
                                                        fontWeight: 400,
                                                        border: "none",
                                                        color:
                                                          themechange == "light"
                                                            ? "#000000 !important"
                                                            : "#ffffff !important",
                                                      }}
                                                    >
                                                      <Typography
                                                        style={{
                                                          fontSize: "14px",
                                                          fontWeight: 700,
                                                          color:
                                                            themechange ==
                                                            "light"
                                                              ? "#000000 !important"
                                                              : "#ffffff !important",
                                                          fontFamily: "Roboto",
                                                          fontWeight: 700,
                                                          fontSize: "12px",
                                                          lineHeight: "14.06px",
                                                          textAlign: "left",
                                                        }}
                                                      >
                                                        {
                                                          maincurrentindividualharmonic.Alias
                                                        }
                                                      </Typography>
                                                    </TableCell>
                                                  );
                                                },
                                              )
                                            ) : (
                                              <></>
                                            )}
                                          </TableRow>
                                        </TableHead>
                                        <TableBody>
                                          <TableRow
                                            key={index}
                                            sx={{
                                              "&:last-child td, &:last-child th":
                                                { border: 0 },
                                              height: "9px",
                                              "& > *": {
                                                borderBottom:
                                                  "1px solid var(--table-boarder-line)",
                                              },
                                            }}
                                          >
                                            {maincondition.individualharmonics.map(
                                              (
                                                maincurrentindividualharmonic,
                                                conditionindex,
                                              ) => {
                                                return (
                                                  <TableCell
                                                    key={conditionindex}
                                                    contentEditable
                                                    suppressHydrationWarning={
                                                      true
                                                    }
                                                    onInput={(e) =>
                                                      handleMainConditionChange(
                                                        index,
                                                        conditionindex,
                                                        "individualharmonics:default_threshold",
                                                        e.target.textContent,
                                                      )
                                                    }
                                                    component="th"
                                                    scope="row"
                                                    sx={{
                                                      width: "9%",
                                                      paddingTop: "10px",
                                                      paddingBottom: "10px",
                                                      fontSize: "14px",
                                                      fontWeight: 400,
                                                      border: "none",
                                                      color:
                                                        themechange == "light"
                                                          ? "#000000 !important"
                                                          : "#ffffff !important",
                                                    }}
                                                  >
                                                    <Typography
                                                      style={{
                                                        fontSize: "12px",
                                                        fontWeight: 400,
                                                        color:
                                                          themechange == "light"
                                                            ? "#000000 !important"
                                                            : "#ffffff !important",
                                                        whiteSpace: "nowrap",
                                                        textOverflow:
                                                          "ellipsis",
                                                        overflow: "hidden",
                                                      }}
                                                    >
                                                      {
                                                        maincurrentindividualharmonic?.default_threshold
                                                      }
                                                    </Typography>
                                                  </TableCell>
                                                );
                                              },
                                            )}
                                          </TableRow>
                                        </TableBody>
                                      </Table>
                                    </TableContainer>
                                  </DialogContent>
                                  <DialogActions
                                    sx={{ justifyContent: "center" }}
                                  >
                                    <CustomCancelButton
                                      onClick={handleCloseCurrentHarmonicDialog}
                                      buttonText={"Cancel"}
                                    ></CustomCancelButton>
                                  </DialogActions>
                                </Dialog>
                              </TableCell>
                              <TableCell
                                component="th"
                                scope="row"
                                sx={{
                                  padding: "0px",
                                  fontSize: "12px",
                                  fontWeight: 400,
                                  color: "var(--grey-variation-tablerowsLK)",
                                  paddingTop: "5px",
                                  paddingBottom: "5px",
                                }}
                              >
                                <TextField
                                  label=""
                                  value={maincondition?.tddthreshold}
                                  variant="standard"
                                  type="number"
                                  onChange={(e) =>
                                    handleMainConditionChange(
                                      index,
                                      "",
                                      "tddthreshold",
                                      e.target.value,
                                    )
                                  }
                                  sx={tableStyles.textFieldStyle}
                                />
                              </TableCell>
                              <TableCell
                                component="th"
                                scope="row"
                                sx={{
                                  padding: "0px",
                                  fontSize: "12px",
                                  fontWeight: 400,
                                  color: "var(--grey-variation-tablerowsLK)",
                                  paddingTop: "2px",
                                  paddingBottom: "2px",
                                }}
                              >
                                <Button
                                  sx={{
                                    width: "20px",
                                    height: "20px",
                                    padding: "0px",
                                    minWidth: "unset",
                                    fontSize: "16px",
                                    fontFamily: "Roboto",
                                    textTransform: "capitalize",
                                    backgroundColor:
                                      "var(--SecondaryBackground)",
                                    borderRadius: "20px",
                                    boxShadow: "none",
                                  }}
                                  variant="text"
                                  onClick={() => handleMainRemoveRow(index)}
                                  disableTouchRipple
                                  elevation={0}
                                >
                                  <LK_Delete
                                    color={"#005C8E"}
                                    width={"20px"}
                                    height={"20px"}
                                  />
                                </Button>
                              </TableCell>
                              <TableCell
                                component="th"
                                scope="row"
                                sx={{
                                  alignItems: "baseline",
                                  padding: "0px",
                                  fontSize: "12px",
                                  fontWeight: 400,
                                  color: "var(--grey-variation-tablerowsLK)",
                                  paddingTop: "2px",
                                  paddingBottom: "2px",
                                }}
                              >
                                {
                                  <div
                                    style={{
                                      display: "flex",
                                      marginTop: 0,
                                      paddingTop: 0,
                                    }}
                                  >
                                    <CustomActionButton
                                      buttonText={"Add Row"}
                                      onClick={handleMainAddRow}
                                    />
                                  </div>
                                }
                              </TableCell>
                            </TableRow>
                          ) : (
                            <></>
                          ),
                        )
                      ) : (
                        <></>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Box>

            {/* Optimized Configure Dashboard Dialog */}
            <Dialog
              open={openDashboardDialog}
              onClose={handleCloseConfigureDashboard}
              fullWidth
              maxWidth="xl"
              BackdropProps={{
                sx: {
                  backgroundColor:
                    themechange === "light"
                      ? "rgba(0,0,0,0.3)"
                      : "rgba(255,255,255,0.3)",
                },
              }}
              sx={{
                "& .MuiDialog-paper": {
                  height: "80vh",
                  width: "100%",
                  borderTopLeftRadius: "40px",
                  borderTopRightRadius: "40px",
                  overflow: "auto",
                  backgroundColor:
                    themechange === "light" ? "#FFFFFF" : "#19191B",
                },
              }}
            >
              <DialogTitle
                sx={{
                  color: "#FFFFFF",
                  backgroundColor: "#005C8E",
                  margin: "5px",
                  borderRadius: "100px",
                }}
              >
                Configure Dashboard
              </DialogTitle>
              <DialogContent
                sx={{
                  width: "98%",
                  height: "100%",
                  backgroundColor: "var(--secondary-backgroundLK)",
                  overflow: "auto",
                  position: "relative",
                }}
              >
                {dialogContentLoading ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    <CircularProgress size={48} />
                  </Box>
                ) : (
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                      gap: "30px",
                    }}
                  >
                    <div
                      style={{
                        width: "30%",
                        position: "sticky",
                        top: 0,
                        marginTop: "23px",
                        height: "100%",
                      }}
                    >
                      <AssetTagsRetrievalModified
                        assetdata={assetdata}
                        setExistingDeviceTagAlarmConfig={
                          setExistingDeviceTagAlarmConfig
                        }
                        setSelectedTag={setSelectedTag}
                        setSelectedAsset={setSelectedAsset}
                        setShowAliasFlag={setShowAliasFlag}
                        selectedTag={selectedTag}
                      />
                      <div style={{ marginLeft: "25px" }}>
                        <Typography
                          onClick={handleOpenAlertsConfig}
                          sx={{
                            fontSize: "18px",
                            fontWeight: 400,
                            color: "#008cd7 !important",
                            fontFamily: "Roboto",
                            textAlign: "left",
                            cursor: "pointer",
                          }}
                        >
                          {"Configure Alerts"}
                        </Typography>
                      </div>
                      <div style={{ marginLeft: "25px", marginTop: "25px" }}>
                        <Typography
                          onClick={handleOpenReportsConfig}
                          sx={{
                            fontSize: "18px",
                            fontWeight: 400,
                            color: "#008cd7 !important",
                            fontFamily: "Roboto",
                            textAlign: "left",
                            cursor: "pointer",
                          }}
                        >
                          {"Configure Reports"}
                        </Typography>
                      </div>
                    </div>
                    <div
                      style={{
                        width: "70%",
                        overflowY: "scroll",
                        height: "100%",
                      }}
                    >
                      {configAlerts == false && configReports == false && (
                        <Box sx={{ width: "100%" }}>
                          <DashboardConfigSection
                            dashboardConfig={dashboardConfig}
                            themechange={themechange}
                            handleInputHarmonicsNumber={
                              handleInputHarmonicsNumber
                            }
                            setFocusedFieldKey={setFocusedFieldKey}
                            showAliasFlag={showAliasFlag}
                            tagdetailsobject={tagdetailsobject}
                            devicedetailsobject={devicedetailsobject}
                          />

                          <VoltageUnbalanceSection
                            dashboardConfig={dashboardConfig}
                            themechange={themechange}
                            setFocusedFieldKey={setFocusedFieldKey}
                            showAliasFlag={showAliasFlag}
                            tagdetailsobject={tagdetailsobject}
                            devicedetailsobject={devicedetailsobject}
                          />

                          <CurrentUnbalanceSection
                            dashboardConfig={dashboardConfig}
                            themechange={themechange}
                            setFocusedFieldKey={setFocusedFieldKey}
                            showAliasFlag={showAliasFlag}
                            tagdetailsobject={tagdetailsobject}
                            devicedetailsobject={devicedetailsobject}
                          />

                          <Typography
                            sx={{
                              fontSize: "16px",
                              fontFamily: "Roboto",
                              color:
                                themechange === "light" ? "#7e7e7e" : "#c1c1c1",
                              fontWeight: 400,
                              marginLeft: "0px",
                              textAlign: "left",
                              marginTop: "10px",
                            }}
                          >
                            No of Harmonics
                          </Typography>
                          <Grid container spacing={2}>
                            {Object.keys(dashboardConfig.noOfHarmonics).map(
                              (event, index) => (
                                <Grid item xs={4} key={event}>
                                  <Typography
                                    sx={{
                                      fontSize: "16px",
                                      fontFamily: "Roboto",
                                      color:
                                        themechange === "light"
                                          ? "#7e7e7e"
                                          : "#c1c1c1",
                                      fontWeight: 400,
                                      marginLeft: "0px",
                                      textAlign: "left",
                                      marginTop: "10px",
                                    }}
                                  >
                                    {dashboardConfig.noOfHarmonics[event].name}
                                  </Typography>
                                  <TextField
                                    key={index}
                                    fullWidth
                                    type="number"
                                    label=""
                                    value={
                                      dashboardConfig.noOfHarmonics[event].value
                                    }
                                    variant="standard"
                                    sx={{
                                      "& .MuiInputBase-input:focus": {
                                        color: "#008CD7",
                                      },
                                      "& .MuiInputBase-root": {
                                        fontFamily: "Roboto",
                                        fontSize: "16px",
                                        fontWeight: "700",
                                        color:
                                          themechange === "light"
                                            ? "#3C3C3C"
                                            : "#FFFFFF",
                                      },
                                      "& .MuiInput-root .MuiInputBase-input":
                                        {},
                                      "& .MuiInputBase-root::before": {
                                        borderBottom: `1px solid ${themechange === "light" ? "#3C3C3C" : "#FFFFFF"}`,
                                      },
                                      "& .MuiInput-underline:hover:not(.Mui-disabled):before":
                                        {
                                          borderBottom: "2px solid #008CD7",
                                        },
                                      "& .MuiInputBase-root::after": {
                                        borderBottom: "2px solid #008CD7",
                                      },
                                      marginBottom: "16px",
                                    }}
                                    onChange={(e) =>
                                      handleInputHarmonicsNumber(
                                        index,
                                        dashboardConfig.noOfHarmonics[event]
                                          .name,
                                        e.target.value,
                                      )
                                    }
                                    placeholder="Enter Number"
                                  />
                                </Grid>
                              ),
                            )}
                          </Grid>

                          <HarmonicsSection
                            title="Individual Current Harmonics (1st to 50th)"
                            harmonics={
                              dashboardConfig.individualCurrentHarmonics
                            }
                            dashboardConfig={dashboardConfig}
                            themechange={themechange}
                            setFocusedFieldKey={setFocusedFieldKey}
                            fieldKey="individualCurrentHarmonics"
                            showAliasFlag={showAliasFlag}
                            tagdetailsobject={tagdetailsobject}
                            devicedetailsobject={devicedetailsobject}
                          />

                          <HarmonicsSection
                            title="Individual Voltage Harmonics (1st to 50th)"
                            harmonics={
                              dashboardConfig.individualVoltageHarmonics
                            }
                            dashboardConfig={dashboardConfig}
                            themechange={themechange}
                            setFocusedFieldKey={setFocusedFieldKey}
                            fieldKey="individualVoltageHarmonics"
                            showAliasFlag={showAliasFlag}
                            tagdetailsobject={tagdetailsobject}
                            devicedetailsobject={devicedetailsobject}
                          />

                          <Typography
                            sx={{
                              fontSize: "16px",
                              fontFamily: "Roboto",
                              color:
                                themechange === "light" ? "#7e7e7e" : "#c1c1c1",
                              fontWeight: 400,
                              marginLeft: "0px",
                              textAlign: "left",
                              marginTop: "10px",
                            }}
                          >
                            Total Demand Distortion
                          </Typography>
                          <Grid container spacing={2}>
                            <Grid item xs={6}>
                              <TextField
                                fullWidth
                                label=""
                                value={
                                  dashboardConfig.totalDemandDistortion.tdd
                                    .value
                                }
                                variant="standard"
                                sx={{
                                  "& .MuiInputBase-input:focus": {
                                    color: "#008CD7",
                                  },
                                  "& .MuiInputBase-root": {
                                    fontFamily: "Roboto",
                                    fontSize: "16px",
                                    fontWeight: "700",
                                    color:
                                      themechange === "light"
                                        ? "#3C3C3C"
                                        : "#FFFFFF",
                                  },
                                  "& .MuiInput-root .MuiInputBase-input": {},
                                  "& .MuiInputBase-root::before": {
                                    borderBottom: `1px solid ${themechange === "light" ? "#3C3C3C" : "#FFFFFF"}`,
                                  },
                                  "& .MuiInput-underline:hover:not(.Mui-disabled):before":
                                    {
                                      borderBottom: "2px solid #008CD7",
                                    },
                                  "& .MuiInputBase-root::after": {
                                    borderBottom: "2px solid #008CD7",
                                  },
                                  marginBottom: "16px",
                                }}
                                onFocus={() =>
                                  setFocusedFieldKey(
                                    "totalDemandDistortion.tdd",
                                  )
                                }
                                readOnly
                                placeholder="Click to select a tag"
                              />
                            </Grid>
                          </Grid>

                          <Typography
                            sx={{
                              fontSize: "16px",
                              fontFamily: "Roboto",
                              color:
                                themechange === "light" ? "#7e7e7e" : "#c1c1c1",
                              fontWeight: 400,
                              marginLeft: "0px",
                              textAlign: "left",
                              marginTop: "10px",
                            }}
                          >
                            Voltage
                          </Typography>
                          <Grid container spacing={2}>
                            <Grid item xs={6}>
                              <TextField
                                fullWidth
                                label=""
                                value={dashboardConfig.voltage.voltage.value}
                                variant="standard"
                                sx={{
                                  "& .MuiInputBase-input:focus": {
                                    color: "#008CD7",
                                  },
                                  "& .MuiInputBase-root": {
                                    fontFamily: "Roboto",
                                    fontSize: "16px",
                                    fontWeight: "700",
                                    color:
                                      themechange === "light"
                                        ? "#3C3C3C"
                                        : "#FFFFFF",
                                  },
                                  "& .MuiInput-root .MuiInputBase-input": {},
                                  "& .MuiInputBase-root::before": {
                                    borderBottom: `1px solid ${themechange === "light" ? "#3C3C3C" : "#FFFFFF"}`,
                                  },
                                  "& .MuiInput-underline:hover:not(.Mui-disabled):before":
                                    {
                                      borderBottom: "2px solid #008CD7",
                                    },
                                  "& .MuiInputBase-root::after": {
                                    borderBottom: "2px solid #008CD7",
                                  },
                                  marginBottom: "16px",
                                }}
                                onFocus={() =>
                                  setFocusedFieldKey("voltage.voltage")
                                }
                                readOnly
                                placeholder="Click to select a tag"
                              />
                            </Grid>
                          </Grid>

                          <Typography
                            sx={{
                              fontSize: "16px",
                              fontFamily: "Roboto",
                              color:
                                themechange === "light" ? "#7e7e7e" : "#c1c1c1",
                              fontWeight: 400,
                              marginLeft: "0px",
                              textAlign: "left",
                              marginTop: "10px",
                            }}
                          >
                            Voltage Total Harmonic Distortion
                          </Typography>
                          <Grid container spacing={2}>
                            {Object.keys(
                              dashboardConfig.voltageTotalHarmonicDistortion,
                            ).map((field) => (
                              <Grid item xs={4} key={field}>
                                <Typography
                                  sx={{
                                    fontSize: "16px",
                                    fontFamily: "Roboto",
                                    color:
                                      themechange === "light"
                                        ? "#7e7e7e"
                                        : "#c1c1c1",
                                    fontWeight: 400,
                                    marginLeft: "0px",
                                    textAlign: "left",
                                    marginTop: "10px",
                                  }}
                                >
                                  {
                                    dashboardConfig
                                      .voltageTotalHarmonicDistortion[field]
                                      .name
                                  }
                                </Typography>
                                <TextField
                                  key={field}
                                  fullWidth
                                  label=""
                                  value={
                                    dashboardConfig
                                      .voltageTotalHarmonicDistortion[field]
                                      .value
                                  }
                                  variant="standard"
                                  sx={{
                                    "& .MuiInputBase-input:focus": {
                                      color: "#008CD7",
                                    },
                                    "& .MuiInputBase-root": {
                                      fontFamily: "Roboto",
                                      fontSize: "16px",
                                      fontWeight: "700",
                                      color:
                                        themechange === "light"
                                          ? "#3C3C3C"
                                          : "#FFFFFF",
                                    },
                                    "& .MuiInput-root .MuiInputBase-input": {},
                                    "& .MuiInputBase-root::before": {
                                      borderBottom: `1px solid ${themechange === "light" ? "#3C3C3C" : "#FFFFFF"}`,
                                    },
                                    "& .MuiInput-underline:hover:not(.Mui-disabled):before":
                                      {
                                        borderBottom: "2px solid #008CD7",
                                      },
                                    "& .MuiInputBase-root::after": {
                                      borderBottom: "2px solid #008CD7",
                                    },
                                    marginBottom: "16px",
                                  }}
                                  onFocus={() =>
                                    setFocusedFieldKey(
                                      "voltageTotalHarmonicDistortion." + field,
                                    )
                                  }
                                  readOnly
                                  placeholder="Click to select a tag"
                                />
                              </Grid>
                            ))}
                          </Grid>

                          <Typography
                            sx={{
                              fontSize: "16px",
                              fontFamily: "Roboto",
                              color:
                                themechange === "light" ? "#7e7e7e" : "#c1c1c1",
                              fontWeight: 400,
                              marginLeft: "0px",
                              textAlign: "left",
                              marginTop: "10px",
                            }}
                          >
                            Current Total Harmonic Distortion
                          </Typography>
                          <Grid container spacing={2}>
                            {Object.keys(
                              dashboardConfig.currentTotalHarmonicDistortion,
                            ).map((field) => (
                              <Grid item xs={4} key={field}>
                                <Typography
                                  sx={{
                                    fontSize: "16px",
                                    fontFamily: "Roboto",
                                    color:
                                      themechange === "light"
                                        ? "#7e7e7e"
                                        : "#c1c1c1",
                                    fontWeight: 400,
                                    marginLeft: "0px",
                                    textAlign: "left",
                                    marginTop: "10px",
                                  }}
                                >
                                  {
                                    dashboardConfig
                                      .currentTotalHarmonicDistortion[field]
                                      .name
                                  }
                                </Typography>
                                <TextField
                                  key={field}
                                  fullWidth
                                  label=""
                                  value={
                                    dashboardConfig
                                      .currentTotalHarmonicDistortion[field]
                                      .value
                                  }
                                  variant="standard"
                                  sx={{
                                    "& .MuiInputBase-input:focus": {
                                      color: "#008CD7",
                                    },
                                    "& .MuiInputBase-root": {
                                      fontFamily: "Roboto",
                                      fontSize: "16px",
                                      fontWeight: "700",
                                      color:
                                        themechange === "light"
                                          ? "#3C3C3C"
                                          : "#FFFFFF",
                                    },
                                    "& .MuiInput-root .MuiInputBase-input": {},
                                    "& .MuiInputBase-root::before": {
                                      borderBottom: `1px solid ${themechange === "light" ? "#3C3C3C" : "#FFFFFF"}`,
                                    },
                                    "& .MuiInput-underline:hover:not(.Mui-disabled):before":
                                      {
                                        borderBottom: "2px solid #008CD7",
                                      },
                                    "& .MuiInputBase-root::after": {
                                      borderBottom: "2px solid #008CD7",
                                    },
                                    marginBottom: "16px",
                                  }}
                                  onFocus={() =>
                                    setFocusedFieldKey(
                                      "currentTotalHarmonicDistortion." + field,
                                    )
                                  }
                                  readOnly
                                  placeholder="Click to select a tag"
                                />
                              </Grid>
                            ))}
                          </Grid>
                        </Box>
                      )}

                      {configAlerts == true && configReports == false && (
                        <>
                          <AlertsConfigSection
                            themechange={themechange}
                            alertRules={alertRules}
                            selectedAlertIndexes={selectedAlertIndexes}
                            handleAlertCheckboxChange={
                              handleAlertCheckboxChange
                            }
                            handleSaveSelectedAlerts={handleSaveSelectedAlerts}
                            handleCloseGoToDashboard={handleCloseGoToDashboard}
                            showAliasFlag={showAliasFlag}
                            tagdetailsobject={tagdetailsobject}
                            devicedetailsobject={devicedetailsobject}
                          />
                          <SaveProgressModal />
                        </>
                      )}

                      {configAlerts == false && configReports == true && (
                        <>
                          {console.log("Reports Tags", tagObjects)}
                          <ReportsConfigSection
                            themechange={themechange}
                            groupCreated={groupCreated}
                            dashboardLinked={dashboardLinked}
                            templateCreated={templateCreated}
                            tagObjects={tagObjects}
                            selectedReportTagObjects={selectedReportTagObjects}
                            handleReportTagCheckboxChange={
                              handleReportTagCheckboxChange
                            }
                            handleAddReportGroup={handleAddReportGroup}
                            handleAddReportTemplate={handleAddReportTemplate}
                            handleDashboardReportGroup={
                              handleDashboardReportGroup
                            }
                            handleCloseGoToDashboard={handleCloseGoToDashboard}
                            showAliasFlag={showAliasFlag}
                            tagdetailsobject={tagdetailsobject}
                            devicedetailsobject={devicedetailsobject}
                          />
                        </>
                      )}
                    </div>
                  </div>
                )}
              </DialogContent>
              <DialogActions sx={{ justifyContent: "center" }}>
                <Button
                  onClick={handleSaveConfiguredDashboard}
                  disabled={dialogContentLoading}
                  sx={{
                    outline: "none !important",
                    boxShadow: "none",
                    height: "35px",
                    width: "125px",
                    fontSize: "16px",
                    textTransform: "capitalize",
                    marginRight: "5px",
                    backgroundColor: "#005C8E",
                    borderRadius: "20px",
                  }}
                  variant="contained"
                  autoFocus
                >
                  Create
                </Button>
                <CustomCancelButton
                  onClick={handleCloseConfigureDashboard}
                  buttonText={"Cancel"}
                />
              </DialogActions>
            </Dialog>

            <CustomDialogBox
              dialogTitle={"Duplicate Tag Assignment"}
              dialogText={duplicateTagDialogMsg}
              openDialog={duplicateTagDialogOpen}
              confirmText={"Ok"}
              cancelText={"Cancel"}
              handleCloseDialog={handleCloseDuplicateTagDialog}
              handleConfirmDialog={handleCloseDuplicateTagDialog}
              type={"Error"}
            />
            {/* All other dialogs remain the same */}
            <CustomDialogBox
              dialogTitle={"Power Quality Details"}
              dialogText={"Could not fetch Power Quality Details.Try Again! "}
              openDialog={notFetchedPQData}
              handleCloseDialog={handleCloseNotFetchedPQData}
              handleConfirmDialog={handleCloseNotFetchedPQData}
              confirmText={"Ok"}
              cancelText={"Cancel"}
              type={""}
            />
            <CustomDialogBox
              dialogTitle={"Power Quality Details"}
              dialogText={
                "Could not get Power Quality Details for Project.Refresh Page "
              }
              openDialog={notGetPQData}
              handleCloseDialog={handleCloseNotGetPQData}
              handleConfirmDialog={handleCloseNotGetPQData}
              confirmText={"Ok"}
              cancelText={"Cancel"}
              type={""}
            />

            <Dialog
              open={openAtLeastOneConditionDialog}
              onClose={handleCloseAtLeastOneConditionDialog}
              BackdropProps={{
                sx: {
                  backgroundColor:
                    themechange == "light"
                      ? "rgba(0,0,0,0.3)"
                      : "rgba(255,255,255,0.3)",
                },
              }}
              sx={{
                "& .MuiDialog-paper": {
                  borderTopLeftRadius: "40px",
                  borderTopRightRadius: "40px",
                  backgroundColor:
                    themechange == "light" ? "#FFFFFF" : "#19191B",
                },
              }}
            >
              <DialogTitle
                sx={{
                  color: "#FFFFFF",
                  backgroundColor: "#005C8E",
                  margin: "5px",
                  borderRadius: "100px",
                }}
              >
                Single Condition
              </DialogTitle>
              <DialogContent>
                <DialogContentText
                  sx={{ color: themechange == "light" ? "#19191B" : "#FFFFFF" }}
                >
                  At least one condition is required
                </DialogContentText>
              </DialogContent>
              <DialogActions sx={{ justifyContent: "center" }}>
                <Button
                  onClick={handleConfirmationAtLeastOneConditionDialog}
                  sx={{
                    outline: "none !important",
                    boxShadow: "none",
                    height: "35px",
                    width: "125px",
                    fontSize: "16px",
                    textTransform: "capitalize",
                    marginRight: "5px",
                    backgroundColor: "#005C8E",
                    borderRadius: "20px",
                  }}
                  variant="contained"
                  autoFocus
                >
                  Ok
                </Button>
                <CustomCancelButton
                  onClick={handleCloseAtLeastOneConditionDialog}
                  buttonText={"Cancel"}
                ></CustomCancelButton>
              </DialogActions>
            </Dialog>

            <Dialog
              open={opensave}
              onClose={handleClose}
              BackdropProps={{
                sx: {
                  backgroundColor:
                    themechange == "light"
                      ? "rgba(0,0,0,0.3)"
                      : "rgba(255,255,255,0.3)",
                },
              }}
              sx={{
                "& .MuiDialog-paper": {
                  borderTopLeftRadius: "40px",
                  borderTopRightRadius: "40px",
                  backgroundColor:
                    themechange == "light" ? "#FFFFFF" : "#19191B",
                },
              }}
            >
              <DialogTitle
                sx={{
                  color: "#FFFFFF",
                  backgroundColor: "#005C8E",
                  margin: "5px",
                  borderRadius: "100px",
                }}
              >
                {"Confirm Save Action"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText
                  sx={{ color: themechange == "light" ? "#19191B" : "#FFFFFF" }}
                >
                  Are you sure you want to save the changes?
                </DialogContentText>
              </DialogContent>
              <DialogActions sx={{ justifyContent: "center" }}>
                <Button
                  onClick={handleSaveChangeConfirm}
                  sx={{
                    outline: "none !important",
                    boxShadow: "none",
                    height: "35px",
                    width: "125px",
                    fontSize: "16px",
                    textTransform: "capitalize",
                    marginRight: "5px",
                    backgroundColor: "#005C8E",
                    borderRadius: "20px",
                  }}
                  variant="contained"
                  autoFocus
                >
                  Confirm
                </Button>
                <CustomCancelButton
                  onClick={handleClose}
                  buttonText={"Cancel"}
                ></CustomCancelButton>
              </DialogActions>
            </Dialog>

            {/* <Dialog
                                open={openAlarmUpdatedandSaved}
                                onClose={handleCloseAlarmUpdatedandSaved}
                                BackdropProps={{
                                    sx:{
                                        backgroundColor: (themechange == 'light')?'rgba(0,0,0,0.3)':'rgba(255,255,255,0.3)'
                                    }
                                }}
                                sx={{ "& .MuiDialog-paper": { borderTopLeftRadius:"40px", borderTopRightRadius:"40px",  backgroundColor:(themechange == 'light')?"#FFFFFF":"#19191B"} }}
                            >
                                <DialogTitle  sx={{color:"#FFFFFF", backgroundColor:"#005C8E",margin:"5px", borderRadius:"100px", }}>Success</DialogTitle>
                                    <DialogContent >
                                        <DialogContentText sx={{color:(themechange == 'light')?"#19191B":"#FFFFFF"}}>
                                            Successfully updated database
                                        </DialogContentText>
                                    </DialogContent>
                                <DialogActions sx={{justifyContent:'center'}}> 
                                    <Button onClick={handleConfirmationAlarmUpdatedandSaved} sx={{ outline:'none !important',boxShadow:'none', height:'35px', width:'125px',fontSize: '16px',textTransform:'capitalize', marginRight:"5px",backgroundColor:"#005C8E", borderRadius:"20px"}} variant="contained" autoFocus>
                                        Ok
                                    </Button>
                                    <CustomCancelButton onClick={handleCloseAlarmUpdatedandSaved} buttonText={'Cancel'}></CustomCancelButton>
                                </DialogActions>
                            </Dialog> */}
            <CustomDialogBox
              dialogTitle={"Power Quality Configuration"}
              dialogText={"Successfully updated database"}
              openDialog={openAlarmUpdatedandSaved}
              handleCloseDialog={handleCloseAlarmUpdatedandSaved}
              handleConfirmDialog={handleConfirmationAlarmUpdatedandSaved}
              confirmText={"Ok"}
              cancelText={"Cancel"}
              type={"Success"}
            />

            {/* <Dialog
                                open={openDuplicateAlarm}
                                onClose={handleCloseDuplicateAlarm}
                                BackdropProps={{
                                    sx:{
                                        backgroundColor: (themechange == 'light')?'rgba(0,0,0,0.3)':'rgba(255,255,255,0.3)'
                                    }
                                }}
                                sx={{ "& .MuiDialog-paper": { borderTopLeftRadius:"40px", borderTopRightRadius:"40px",  backgroundColor:(themechange == 'light')?"#FFFFFF":"#19191B"} }}
                            >
                                <DialogTitle  sx={{color:"#FFFFFF", backgroundColor:"#005C8E",margin:"5px", borderRadius:"100px", }}>Error</DialogTitle>
                                    <DialogContent >
                                        <DialogContentText sx={{color:(themechange == 'light')?"#19191B":"#FFFFFF"}}>
                                            Database Could not be updated - Try again 
                                        </DialogContentText>
                                    </DialogContent>
                                <DialogActions sx={{justifyContent:'center'}}> 
                                    <Button onClick={handleConfirmationDuplicateAlarm} sx={{ outline:'none !important',boxShadow:'none', height:'35px', width:'125px',fontSize: '16px',textTransform:'capitalize', marginRight:"5px",backgroundColor:"#005C8E", borderRadius:"20px"}} variant="contained" autoFocus>
                                        Ok
                                    </Button>
                                    <CustomCancelButton onClick={handleCloseDuplicateAlarm} buttonText={'Cancel'}></CustomCancelButton>
                                </DialogActions>
                            </Dialog> */}

            <CustomDialogBox
              dialogTitle={"Power Quality Configuration"}
              dialogText={"Database Could not be updated - Try again"}
              openDialog={openDuplicateAlarm}
              handleCloseDialog={handleCloseDuplicateAlarm}
              handleConfirmDialog={handleConfirmationDuplicateAlarm}
              confirmText={"Ok"}
              cancelText={"Cancel"}
              type={"Error"}
            />

            <Dialog
              open={invalidLimits}
              onClose={handleCloseinvalidLimits}
              BackdropProps={{
                sx: {
                  backgroundColor:
                    themechange == "light"
                      ? "rgba(0,0,0,0.3)"
                      : "rgba(255,255,255,0.3)",
                },
              }}
              sx={{
                "& .MuiDialog-paper": {
                  borderTopLeftRadius: "40px",
                  borderTopRightRadius: "40px",
                  backgroundColor:
                    themechange == "light" ? "#FFFFFF" : "#19191B",
                },
              }}
            >
              <DialogTitle
                sx={{
                  color: "#FFFFFF",
                  backgroundColor: "#005C8E",
                  margin: "5px",
                  borderRadius: "100px",
                }}
              >
                Invalid Input
              </DialogTitle>
              <DialogContent>
                <DialogContentText
                  sx={{ color: themechange == "light" ? "#19191B" : "#FFFFFF" }}
                >
                  Please enter Thresholds between 0 and 100000
                </DialogContentText>
              </DialogContent>
              <DialogActions sx={{ justifyContent: "center" }}>
                <Button
                  onClick={handleCloseinvalidLimits}
                  sx={{
                    outline: "none !important",
                    boxShadow: "none",
                    height: "35px",
                    width: "125px",
                    fontSize: "16px",
                    textTransform: "capitalize",
                    marginRight: "5px",
                    backgroundColor: "#005C8E",
                    borderRadius: "20px",
                  }}
                  variant="contained"
                  autoFocus
                >
                  Ok
                </Button>
                <CustomCancelButton
                  onClick={handleCloseinvalidLimits}
                  buttonText={"Cancel"}
                ></CustomCancelButton>
              </DialogActions>
            </Dialog>

            <Dialog
              open={invalidLimitsLowerUpper}
              onClose={handleCloseinvalidLimitsLowerUpper}
              BackdropProps={{
                sx: {
                  backgroundColor:
                    themechange == "light"
                      ? "rgba(0,0,0,0.3)"
                      : "rgba(255,255,255,0.3)",
                },
              }}
              sx={{
                "& .MuiDialog-paper": {
                  borderTopLeftRadius: "40px",
                  borderTopRightRadius: "40px",
                  backgroundColor:
                    themechange == "light" ? "#FFFFFF" : "#19191B",
                },
              }}
            >
              <DialogTitle
                sx={{
                  color: "#FFFFFF",
                  backgroundColor: "#005C8E",
                  margin: "5px",
                  borderRadius: "100px",
                }}
              >
                Invalid Range
              </DialogTitle>
              <DialogContent>
                <DialogContentText
                  sx={{ color: themechange == "light" ? "#19191B" : "#FFFFFF" }}
                >
                  Please ensure lower threshold is less than upper threshold
                </DialogContentText>
              </DialogContent>
              <DialogActions sx={{ justifyContent: "center" }}>
                <Button
                  onClick={handleCloseinvalidLimitsLowerUpper}
                  sx={{
                    outline: "none !important",
                    boxShadow: "none",
                    height: "35px",
                    width: "125px",
                    fontSize: "16px",
                    textTransform: "capitalize",
                    marginRight: "5px",
                    backgroundColor: "#005C8E",
                    borderRadius: "20px",
                  }}
                  variant="contained"
                  autoFocus
                >
                  Ok
                </Button>
                <CustomCancelButton
                  onClick={handleCloseinvalidLimitsLowerUpper}
                  buttonText={"Cancel"}
                ></CustomCancelButton>
              </DialogActions>
            </Dialog>

            <Dialog
              open={deletevoltageConfirmation}
              onClose={handleClosedeletevoltageConfirmation}
              BackdropProps={{
                sx: {
                  backgroundColor:
                    themechange == "light"
                      ? "rgba(0,0,0,0.3)"
                      : "rgba(255,255,255,0.3)",
                },
              }}
              sx={{
                "& .MuiDialog-paper": {
                  borderTopLeftRadius: "40px",
                  borderTopRightRadius: "40px",
                  backgroundColor:
                    themechange == "light" ? "#FFFFFF" : "#19191B",
                },
              }}
            >
              <DialogTitle
                sx={{
                  color: "#FFFFFF",
                  backgroundColor: "#005C8E",
                  margin: "5px",
                  borderRadius: "100px",
                }}
              >
                Confirm Delete
              </DialogTitle>
              <DialogContent>
                <DialogContentText
                  sx={{ color: themechange == "light" ? "#19191B" : "#FFFFFF" }}
                >
                  Are you sure to delete voltage harmonics configurations?
                </DialogContentText>
              </DialogContent>
              <DialogActions sx={{ justifyContent: "center" }}>
                <Button
                  onClick={handleConfirmdeletevoltageConfirmation}
                  sx={{
                    outline: "none !important",
                    boxShadow: "none",
                    height: "35px",
                    width: "125px",
                    fontSize: "16px",
                    textTransform: "capitalize",
                    marginRight: "5px",
                    backgroundColor: "#005C8E",
                    borderRadius: "20px",
                  }}
                  variant="contained"
                  autoFocus
                >
                  Confirm
                </Button>
                <CustomCancelButton
                  onClick={handleClosedeletevoltageConfirmation}
                  buttonText={"Cancel"}
                ></CustomCancelButton>
              </DialogActions>
            </Dialog>

            <Dialog
              open={deletecurrentConfirmation}
              onClose={handleClosedeletecurrentConfirmation}
              BackdropProps={{
                sx: {
                  backgroundColor:
                    themechange == "light"
                      ? "rgba(0,0,0,0.3)"
                      : "rgba(255,255,255,0.3)",
                },
              }}
              sx={{
                "& .MuiDialog-paper": {
                  borderTopLeftRadius: "40px",
                  borderTopRightRadius: "40px",
                  backgroundColor:
                    themechange == "light" ? "#FFFFFF" : "#19191B",
                },
              }}
            >
              <DialogTitle
                sx={{
                  color: "#FFFFFF",
                  backgroundColor: "#005C8E",
                  margin: "5px",
                  borderRadius: "100px",
                }}
              >
                Single Condition
              </DialogTitle>
              <DialogContent>
                <DialogContentText
                  sx={{ color: themechange == "light" ? "#19191B" : "#FFFFFF" }}
                >
                  Are you sure to delete current harmonics configurations?
                </DialogContentText>
              </DialogContent>
              <DialogActions sx={{ justifyContent: "center" }}>
                <Button
                  onClick={handleConfirmdeletecurrentConfirmation}
                  sx={{
                    outline: "none !important",
                    boxShadow: "none",
                    height: "35px",
                    width: "125px",
                    fontSize: "16px",
                    textTransform: "capitalize",
                    marginRight: "5px",
                    backgroundColor: "#005C8E",
                    borderRadius: "20px",
                  }}
                  variant="contained"
                  autoFocus
                >
                  Confirm
                </Button>
                <CustomCancelButton
                  onClick={handleClosedeletecurrentConfirmation}
                  buttonText={"Cancel"}
                ></CustomCancelButton>
              </DialogActions>
            </Dialog>
            <CustomDialogBox
              dialogTitle={"Delete Current Harmonics Configuration"}
              dialogText={
                "Failed to delete current harmonics configuration. Try Again! "
              }
              openDialog={deleteCurrentHarmonicsFailed}
              handleCloseDialog={handleCloseDeleteCurrentHarmonicFailed}
              handleConfirmDialog={handleCloseDeleteCurrentHarmonicFailed}
              confirmText={"Ok"}
              cancelText={"Cancel"}
              type={"Error"}
            />
            <CustomDialogBox
              dialogTitle={"Delete Current Harmonics Configuration"}
              dialogText={
                "Successfully deleted current harmonics configuration "
              }
              openDialog={deleteCurrentHarmonicsSuccess}
              handleCloseDialog={handleCloseDeleteCurrentHarmonicSuccess}
              handleConfirmDialog={handleCloseDeleteCurrentHarmonicSuccess}
              confirmText={"Ok"}
              cancelText={"Cancel"}
              type={"Success"}
            />

            <Dialog
              open={fetchdataConfirm}
              onClose={handleClosefetchDataConfirm}
              BackdropProps={{
                sx: {
                  backgroundColor:
                    themechange == "light"
                      ? "rgba(0,0,0,0.3)"
                      : "rgba(255,255,255,0.3)",
                },
              }}
              sx={{
                "& .MuiDialog-paper": {
                  borderTopLeftRadius: "40px",
                  borderTopRightRadius: "40px",
                  backgroundColor:
                    themechange == "light" ? "#FFFFFF" : "#19191B",
                },
              }}
            >
              <DialogTitle
                sx={{
                  color: "#FFFFFF",
                  backgroundColor: "#005C8E",
                  margin: "5px",
                  borderRadius: "100px",
                }}
              >
                Import Details
              </DialogTitle>
              <DialogContent>
                <DialogContentText
                  sx={{ color: themechange == "light" ? "#19191B" : "#FFFFFF" }}
                >
                  Import Power Quality Parameters Details
                </DialogContentText>
              </DialogContent>
              <DialogActions sx={{ justifyContent: "center" }}>
                <Button
                  onClick={handlefetchDataConfirm}
                  sx={{
                    outline: "none !important",
                    boxShadow: "none",
                    height: "35px",
                    width: "125px",
                    fontSize: "16px",
                    textTransform: "capitalize",
                    marginRight: "5px",
                    backgroundColor: "#005C8E",
                    borderRadius: "20px",
                  }}
                  variant="contained"
                  autoFocus
                >
                  Yes
                </Button>
                <CustomCancelButton
                  onClick={handleClosefetchDataConfirm}
                  buttonText={"No"}
                ></CustomCancelButton>
              </DialogActions>
            </Dialog>
            <CustomDialogBox
              dialogTitle={"Delete Voltage Harmonics Configuration"}
              dialogText={
                "Failed to delete voltage harmonics configuration. Try Again! "
              }
              openDialog={deleteVoltageHarmonicsFailed}
              handleCloseDialog={handleCloseDeleteVoltageHarmonicFailed}
              handleConfirmDialog={handleCloseDeleteVoltageHarmonicFailed}
              confirmText={"Ok"}
              cancelText={"Cancel"}
              type={"Error"}
            />
            <CustomDialogBox
              dialogTitle={"Delete Voltage Harmonics Configuration"}
              dialogText={
                "Successfully deleted voltage harmonics configuration "
              }
              openDialog={deleteVoltageHarmonicsSuccess}
              handleCloseDialog={handleCloseDeleteVoltageHarmonicSuccess}
              handleConfirmDialog={handleCloseDeleteVoltageHarmonicSuccess}
              confirmText={"Ok"}
              cancelText={"Cancel"}
              type={"Success"}
            />
          </Box>
        </Box>
      )}
      {viewDashboard == true && (
        <Suspense fallback={<div>Loading Dashboard...</div>}>
          <Box
            className="compliance-config"
            sx={{ height: "100%", boxSizing: "border-box", width: "100%" }}
          >
            <Box
              sx={{
                padding: "0px",
                height: "calc(100% - 0px)",
                width: "100%",
                boxSizing: "border-box",
              }}
            >
              <Box
                sx={{
                  padding: "0px",
                  width: "100%",
                  height: "7%",
                  boxSizing: "border-box",
                  display: "flex",
                  gap: "8px",
                }}
              >
                <Box sx={{ flexGrow: 1 }}></Box>
                <CustomCancelButton
                  onClick={handleCancelViewDashboard}
                  buttonText={"Cancel"}
                ></CustomCancelButton>
              </Box>
              <PowerQualityStandardDashboards />
            </Box>
          </Box>
        </Suspense>
      )}
      <CustomDialogBox
        dialogTitle={"Created Dashboard Successfully"}
        dialogText={"Dashboard Successfully created "}
        openDialog={createdSucess}
        handleCloseDialog={handleCloseCreateDashboard}
        handleConfirmDialog={handleCloseCreateDashboard}
        confirmText={"Ok"}
        cancelText={"Cancel"}
        type={"Success"}
      />
      <CustomDialogBox
        dialogTitle={"Created Dashboard Failed"}
        dialogText={notCreatedMessage}
        openDialog={notCreatedSuccess}
        handleCloseDialog={handleCloseNotCreateDashboard}
        handleConfirmDialog={handleCloseNotCreateDashboard}
        confirmText={"Ok"}
        cancelText={"Cancel"}
        type={"Error"}
      />
      <CustomDialogBox
        dialogTitle={"Creation of Dashboard Failed"}
        dialogText={
          "Check if Dashboard Name has length between 5-30 characters and no special characters"
        }
        openDialog={openAlertRuleNameExceedsLength}
        handleCloseDialog={handleAlertRuleNameExceedsLength}
        handleConfirmDialog={handleAlertRuleNameExceedsLength}
        confirmText={"Ok"}
        cancelText={"Cancel"}
        type={"Error"}
      />
    </>
  );
}
